import { WeborderingConfiguration } from 'services/brand/brand.type';

export const weborderingConfigurationMock = {
    brandId: 10,
    brandHash: '2f250927455d',
    name: 'Eat n Drinkk',
    locale: 'en-GB',
    currency: 'EUR',
    contactPhone: '0879685745',
    contactEmail: 'mamso2s@flex.fr',
    websiteUrl: 'eat.fr',
    websiteCustomCssUrl:
        'https://static-dev.innovorder.fr/webcss/2-10-e78c077c2c1df9847a1130fb2d3c4d45.css',
    is_enabled: true,
    legalId: 6,
    socialNetworkId: 7,
    moduleStripeId: 17,
    isEmailWhitelistingEnabled: false,
    externalId: '048164',
    created_at: '2017-01-31T16:27:12.000Z',
    updated_at: '2022-08-09T00:25:01.000Z',
    brandType: 'MASS_CATERING',
    note: null,
    moduleLoyaltyRoyalties: [
        {
            moduleLoyaltyRoyaltyId: 1,
            is_enabled: true,
            percentage: 8000,
            moduleId: 17,
            brandId: 10,
            restaurantId: null,
            channelId: 6,
            customCss:
                '#intro * {\n    margin: 0;\n    padding: 0;\n}\n\n#intro .description {\n    margin-top: 20px;\n    margin-bottom: 50px;\n    width: 80%;\n    text-align: center;\n}\n\n#intro .content-container {\n    width: 100%;\n    padding-bottom: 30px;\n}\n\n#intro .content-container h4 {\n    text-align: center;\n    margin-bottom: 10px;\n}\n\n\n#intro .content-container .perks {\n    background-color: #fdfdfd;\n    border: solid 1px #e2e2e2;\n    padding: 20px 0;\n    width: 100%;\n    margin: 10px 0;\n}\n\n#intro .content-container .perks h5 {\n    font-family: avenir-heavy;\n    text-transform: uppercase;\n}\n\n#intro .content-container .perks i {\n    /*color: $brand-color;*/\n    font-size: 24px;\n}\n\n#intro .content-container .perks p {\n    font-size: 12px;\n}\n    \n#intro .content-container fio-button {\n    /*background-color: $brand-color;*/\n    font-size: 20px;\n    font-family: avenir-heavy;\n    padding: 15px 70px;\n    border-radius: 4px;\n    /*color: $text-on-brand;*/\n    margin-bottom: 20px;\n}',
            customHtmlMessage:
                '<div layout="column" layout-align="center center">\n    <p class="description">Grâce à votre carte de fidélité Fresh Burritos, vous cumulez des euros à chacune de vos visites dans nos restaurants ou de vos commandes passées sur notre site internet.</p>\n    <section class="content-container">\n        <h4>Découvrez les avantages de la carte de fidélité</h4>\n        <div class="perks" layout="row" layout-align="space-around center">\n            <i class="icon icon-feed-price"></i>\n            <div flex="80">\n                <h5>5% DE VOTRE NOTE CRÉDITÉ EN AVOIR</h5>\n                <p>sur votre carte à chaque passage en caisse</p>\n            </div>\n        </div>\n        <div class="perks" layout="row" layout-align="space-around center">\n            <i class="icon icon-feed-wallet"></i>\n            <div flex="80">\n                <h5>VOTRE COMPTE FIDÉLITÉ</h5>\n                <p>consultable à tout moment sur internet.</p>\n            </div>\n        </div>\n        <div class="perks" layout="row" layout-align="space-around center">\n            <i class="icon icon-coin-euro"></i>\n            <div flex="80">\n                <h5>VOTRE SOLDE D\'EUROS SAUVEGARDÉ</h5>\n                <p>même en cas de perte de votre carte ! </p>\n            </div>\n        </div>\n    </section>\n</div>\n',
            created_at: '2017-06-23T16:57:24.000Z',
            updated_at: '2022-04-15T08:41:12.000Z',
            deleted_at: null,
        },
    ],
    channels: [
        {
            channelId: 2,
            name: 'web',
            canBeBlocked: true,
            is_enabled: true,
            isReportSource: true,
            created_at: '2017-01-30T01:11:12.000Z',
            updated_at: '2017-01-30T01:11:12.000Z',
            brand_channel: {
                brandId: 10,
                channelId: 2,
                created_at: '2020-04-05T13:14:49.000Z',
                updated_at: '2020-04-05T13:14:49.000Z',
            },
        },
    ],
    module_style_styles: [
        {
            moduleStyleStyleId: 23,
            is_enabled: true,
            moduleId: 3,
            brandId: 10,
            restaurantId: null,
            channelId: 2,
            styleId: 24,
            created_at: '2017-01-31T16:27:14.000Z',
            updated_at: '2017-01-31T16:27:14.000Z',
            style: {
                styleId: 24,
                name: null,
                theme: 'light',
                mobileAccentBackground: '#FFFFFF',
                principalColor: '#1849ff',
                separatorColor: '#EBEBEB',
                backgroundColor: '#F9F9F9',
                textOnBrandColor: '#FFFFFF',
                hoverBackgroundColor: '#F4F4F4',
                overlayColor: '#161616',
                overlayOpacity: 80,
                displayProduct: 'column',
                roundCorner: 20,
                displayHeader: true,
                displayFooter: true,
                titleFont: 'https://static-dev.innovorder.fr/uploads/0/fonts/avenir-book.ttf',
                titleColor: '#4B4646',
                titleIsUppercase: false,
                textFont: 'https://static-dev.innovorder.fr/uploads/0/fonts/avenir-book.ttf',
                textColor: '#929292',
                textIsUppercase: false,
                backgroundImage:
                    'https://static-dev.innovorder.fr/uploads/2f250927455d/47dba66d76c83fb20f018505f4a259c7.jpg',
                logoImage:
                    'https://static-dev.innovorder.fr/uploads/2f250927455d/8cc9dd280bb760a87404526404ae14b4.jpg',
                logoBrandImage:
                    'https://static-dev.innovorder.fr/uploads/2f250927455d/4e62299a441fde09113053e4747a4feb.jpg',
                kioskImage: null,
                isSlideshowEnabled: false,
                slideshow: null,
                customCss:
                    '.class {\n    font: test;\n}\n\n.test1 {\n     \n     \n    font: test;\n}\n',
                created_at: '2017-01-31T16:27:14.000Z',
                updated_at: '2022-04-15T08:48:28.000Z',
                is_enabled: true,
                channelId: null,
                brandId: null,
                restaurantId: null,
            },
        },
    ],
    module_ordering_flows: [
        {
            termsAndConditions: null,
            termsOfUse: null,
            legalNotice: null,
            registrationConditions:
                '<div><div>Vous allez <a href="http://google.fr">communiquer</a> vos données à caractère personnel dans le cadre de la création de votre compte qui vous permet de commander en ligne et de bénéficier d’offres et d’avantages sur les produits proposés par les restaurants de l’enseigne Poivre Rouge. Les champs marqués d’un astérisque doivent être renseignés obligatoirement pour valider votre inscription. A défaut, votre demande d’inscription ne sera pas prise en compte. Vos données à caractère personnel sont collectées à des fins de traitement de vos commandes en lignes, la réalisation d’actions de fidélisation ainsi qu’à des fins de prospection commerciale. Les traitements de données à caractère personnel mentionnés sont juridiquement basés sur votre consentement et l’exécution du contrat conclu avec ITM RESTAURATION. Le responsable de traitement est ITM RESTAURATION, située 3 allée des Mousquetaires. ITM RESTAURATION peut recourir à des sous-traitants. Les destinataires de vos données personnelles sont les restaurants portant l’enseigne Poivre Rouge.</div><div>Les données collectées sont conservées, par défaut, pour une durée de trois ans à compter de leur collecte ou, le cas échéant, de votre dernière connexion à votre compte puis supprimées. ITM RESTAURATION conserve ces données pour une durée plus importante lorsque les obligations légales et réglementaires l’imposent.</div><div>Conformément au Règlement général pour la protection des données n°2016/679 et à la loi dite « Informatique et libertés » du 6 janvier 1978 dans sa dernière version, vous disposez d’un droit d’accès, de rectification, d’effacement des données à caractère personnel qui vous concernent, d’un droit à la limitation du traitement, d’un droit d’opposition, d’un droit à la portabilité de vos données et du droit de définir des directives relatives à la conservation, à l\'effacement et à la communication de vos données à caractère personnel après votre décès.</div><div>Vous pouvez exercer vos droits en vous adressant directement par courrier postal au Service Marketing Poivre Rouge 3 Allée des Mousquetaires 91078 Bondoufle Cedex.</div><div>Pour toute autre demande, vous pouvez également contacter le délégué à la protection des données par courriel à l’adresse dpolesmousquetaires@mousquetaires.com</div><div>En cas de réclamation, vous disposez du droit de saisir la CNIL.</div></div><div><br></div><p></p>',
            customMessage:
                "si vous souffrez d'allergies alimentaires ou si vous suivez un régime alimentaire spécifique veuillez en aviser directement le restaurant avant de passer votre commande.",
            emailCustomMessage: 'TOTO<p></p>',
            moduleOrderingFlowId: 20,
            created_at: '2017-01-31T16:27:14.000Z',
            updated_at: '2022-05-18T13:20:21.000Z',
            ewalletPaymentActivated: true,
            stripePaymentActivated: false,
            adminCode: '0000',
            isAlcoolBannerActivated: false,
            isEwalletReloadButtonHidden: false,
            isWeborderingButtonHidden: false,
            isDeliveryEnabled: true,
            isProductDisplayedWhenUnavailable: false,
            isRegistrationEnabled: true,
            isLoginEnabled: false,
            isNFCLoginEnabled: false,
            loginStrategy: 3,
            authenticationEwalletCondition: false,
            nfcCardStrategy: 'MIFARE_UID',
            allowAuthAndUnauthOnKiosk: false,
            JWTSecretKey: 'your-256-bit-secret',
            timechefWebhookOrderPushEnabled: false,
            forceOnlinePaymentForTakeAway: false,
            isCNTRELuncheonVoucherDeclared: false,
            isTakeAwayEnabled: true,
            isSitInEnabled: true,
            serviceCharge: 0,
            takeAwayReduction: 1000,
            rushDelay: 0,
            openAt: '2017-01-31T16:27:14.000Z',
            kioskCssUrl: null,
            is_enabled: true,
            moduleId: 2,
            brandId: 10,
            restaurantId: null,
            channelId: 2,
            kioskCount: 0,
            confirmationMessage: null,
            confirmationTime: 6000,
            surveyUrl: null,
            blindCarbonCopy: null,
            isCustomCopyEmailEnabled: false,
            customCopyEmailSubject: null,
            customCopyEmailTemplate: null,
            enableCustomerEmail: true,
            useRegistrationConditions: false,
            onlinePaymentDiscount: null,
            invoiceDownloadEnabled: true,
            afterOrderReturnButtonText: null,
            afterOrderReturnButtonLink: null,
            orderFinalValidation: false,
            useGTMCookiePolicyAsDefault: true,
        },
    ],
    module_website_meta: [
        {
            websiteHost: 'eatndrink-dev.innovorder.io',
            isSslActive: true,
            title: "Eat'N'Drinks",
        },
    ],
    socialNetwork: {
        socialNetworkId: 7,
        is_enabled: true,
        facebook: 'https://facebook.com',
        googleplus: null,
        instagram: null,
        twitter: 'https://twitter.com/barackobama',
        pinterest: '',
        linkedin: null,
        yelp: null,
        tripAdvisor: 'https://www.tripadvisor.com',
        tracktl: 'https://twitter.com/barackobama',
        created_at: '2017-07-28T12:43:56.000Z',
        updated_at: '2021-08-24T15:49:34.000Z',
    },
    brandModuleStripe: {
        moduleStripeId: 17,
        label: "Eat'n'drink Stripe",
        isCNTRELuncheonVoucherDeclared: false,
        stripeUserId: 'acct_1KTNUXFscUAPoZMJ',
        stripePublishableKey:
            'pk_test_51KTNUXFscUAPoZMJ36xNbGicJoltoCMjOSBDhYqjQ3tPTVCnnBqrn03HKbbsVqgIrEeOKl2tLYIl8Nmtbo8vqmoM00054wkYxN',
        liveMode: false,
        isActivated: true,
        stateConnect: null,
        brandId: 10,
        created_at: '2017-09-01T10:08:27.000Z',
        updated_at: '2022-02-15T09:38:39.000Z',
        deleted_at: null,
    },
    options: {
        EDUCATION_MODE: {
            optionId: 1,
            nameValue: 'EDUCATION_MODE',
            isActivated: true,
            restaurantId: null,
            brandId: 10,
            created_at: '2017-07-26T08:31:00.000Z',
            updated_at: '2022-05-05T13:04:52.000Z',
            deleted_at: null,
        },
        OPT_IN: {
            optionId: 7,
            nameValue: 'OPT_IN',
            isActivated: true,
            restaurantId: null,
            brandId: 10,
            created_at: '2017-10-04T16:27:42.000Z',
            updated_at: '2021-01-06T15:13:58.000Z',
            deleted_at: null,
        },
        TRIP_ADVISOR_USERNAME: {
            optionId: 8,
            nameValue: 'TRIP_ADVISOR_USERNAME',
            isActivated: false,
            restaurantId: null,
            brandId: 10,
            created_at: '2017-10-05T08:50:10.000Z',
            updated_at: '2022-06-06T10:17:21.000Z',
            deleted_at: null,
        },
        ADVANCED_SECURITY_RULES: {
            optionId: 9,
            nameValue: 'ADVANCED_SECURITY_RULES',
            isActivated: false,
            restaurantId: null,
            brandId: 10,
            created_at: '2017-10-05T08:50:10.000Z',
            updated_at: '2022-01-11T16:56:53.000Z',
            deleted_at: null,
        },
        BIRTHDATE: {
            optionId: 10,
            nameValue: 'BIRTHDATE',
            isActivated: false,
            restaurantId: null,
            brandId: 10,
            created_at: '2017-10-05T08:50:10.000Z',
            updated_at: '2022-05-20T06:13:26.000Z',
            deleted_at: null,
        },
        GRANTS_AND_ENTRANCE_FEE: {
            optionId: 34,
            nameValue: 'GRANTS_AND_ENTRANCE_FEE',
            isActivated: true,
            restaurantId: null,
            brandId: 10,
            created_at: '2017-12-04T15:45:42.000Z',
            updated_at: '2022-06-06T14:11:54.000Z',
            deleted_at: null,
        },
        PIN_CODE_DOUBLE_ATHENTICATION: {
            optionId: 43,
            nameValue: 'PIN_CODE_DOUBLE_ATHENTICATION',
            isActivated: true,
            restaurantId: null,
            brandId: 10,
            created_at: '2018-01-05T14:09:44.000Z',
            updated_at: '2022-01-24T20:47:18.000Z',
            deleted_at: null,
        },
        PRODUCTION_DECLARATION: {
            optionId: 44,
            nameValue: 'PRODUCTION_DECLARATION',
            isActivated: true,
            restaurantId: null,
            brandId: 10,
            created_at: '2018-01-05T14:09:46.000Z',
            updated_at: '2018-07-16T14:24:57.000Z',
            deleted_at: null,
        },
        CHARLEMAGNE_EXPORT: {
            optionId: 102,
            nameValue: 'CHARLEMAGNE_EXPORT',
            isActivated: true,
            restaurantId: null,
            brandId: 10,
            created_at: '2018-07-16T14:24:57.000Z',
            updated_at: '2019-01-07T12:54:56.000Z',
            deleted_at: null,
        },
        SMS_SENDING: {
            optionId: 103,
            nameValue: 'SMS_SENDING',
            isActivated: false,
            restaurantId: null,
            brandId: 10,
            created_at: '2018-07-19T10:07:40.000Z',
            updated_at: '2021-05-05T11:43:12.000Z',
            deleted_at: null,
        },
        HANDLE_BADGE_4_CHAR: {
            optionId: 132,
            nameValue: 'HANDLE_BADGE_4_CHAR',
            isActivated: false,
            restaurantId: null,
            brandId: 10,
            created_at: '2019-03-31T11:04:44.000Z',
            updated_at: '2022-04-20T15:15:20.000Z',
            deleted_at: null,
        },
        FORCE_DEFAULT_CREDENTIALS_CHANGE: {
            optionId: 161,
            nameValue: 'FORCE_DEFAULT_CREDENTIALS_CHANGE',
            isActivated: false,
            restaurantId: null,
            brandId: 10,
            created_at: '2019-11-27T16:05:43.000Z',
            updated_at: '2022-04-15T08:43:21.000Z',
            deleted_at: null,
        },
        FORCE_DEFAULT_BADGE_GENERATION: {
            optionId: 365,
            nameValue: 'FORCE_DEFAULT_BADGE_GENERATION',
            isActivated: false,
            restaurantId: null,
            brandId: 10,
            created_at: '2021-10-11T15:21:42.000Z',
            updated_at: '2021-10-11T15:21:42.000Z',
            deleted_at: null,
        },
        AUTO_BILLING: {
            optionId: 432,
            nameValue: 'AUTO_BILLING',
            isActivated: true,
            restaurantId: null,
            brandId: 10,
            created_at: '2022-05-05T18:26:32.000Z',
            updated_at: '2022-05-13T10:38:43.000Z',
            deleted_at: null,
        },
    },
    restaurants: [
        {
            restaurantId: 689,
            name: 'El Jose Bove',
            delayTakeAway: null,
            phoneIndicator: null,
            contactPhone: '0123456789',
            contactName: 'Jose Bove',
            contactEmail: 'jose.bove@gmail.com',
            brandId: 10,
            addressId: 1860,
            locale: 'fr',
            kitchenDisplayId: 34,
            currency: 'EUR',
            created_at: '2021-06-14T09:31:27.000Z',
            updated_at: '2021-06-14T10:19:28.000Z',
            is_enabled: true,
            legalId: 95,
            ewalletMinimumForScanTray: null,
            moduleStripeId: 66,
            modulePaygreenId: null,
            moduleSplioId: null,
            moduleApetizPlusId: null,
            externalId: null,
            moduleNeptingId: null,
            lastShiftClosureHour: null,
            module_ordering_flows: [
                {
                    termsAndConditions: null,
                    termsOfUse: null,
                    legalNotice: null,
                    registrationConditions:
                        '<div><div>Vous allez <a href="http://google.fr">communiquer</a> vos données à caractère personnel dans le cadre de la création de votre compte qui vous permet de commander en ligne et de bénéficier d’offres et d’avantages sur les produits proposés par les restaurants de l’enseigne Poivre Rouge. Les champs marqués d’un astérisque doivent être renseignés obligatoirement pour valider votre inscription. A défaut, votre demande d’inscription ne sera pas prise en compte. Vos données à caractère personnel sont collectées à des fins de traitement de vos commandes en lignes, la réalisation d’actions de fidélisation ainsi qu’à des fins de prospection commerciale. Les traitements de données à caractère personnel mentionnés sont juridiquement basés sur votre consentement et l’exécution du contrat conclu avec ITM RESTAURATION. Le responsable de traitement est ITM RESTAURATION, située 3 allée des Mousquetaires. ITM RESTAURATION peut recourir à des sous-traitants. Les destinataires de vos données personnelles sont les restaurants portant l’enseigne Poivre Rouge.</div><div>Les données collectées sont conservées, par défaut, pour une durée de trois ans à compter de leur collecte ou, le cas échéant, de votre dernière connexion à votre compte puis supprimées. ITM RESTAURATION conserve ces données pour une durée plus importante lorsque les obligations légales et réglementaires l’imposent.</div><div>Conformément au Règlement général pour la protection des données n°2016/679 et à la loi dite « Informatique et libertés » du 6 janvier 1978 dans sa dernière version, vous disposez d’un droit d’accès, de rectification, d’effacement des données à caractère personnel qui vous concernent, d’un droit à la limitation du traitement, d’un droit d’opposition, d’un droit à la portabilité de vos données et du droit de définir des directives relatives à la conservation, à l\'effacement et à la communication de vos données à caractère personnel après votre décès.</div><div>Vous pouvez exercer vos droits en vous adressant directement par courrier postal au Service Marketing Poivre Rouge 3 Allée des Mousquetaires 91078 Bondoufle Cedex.</div><div>Pour toute autre demande, vous pouvez également contacter le délégué à la protection des données par courriel à l’adresse dpolesmousquetaires@mousquetaires.com</div><div>En cas de réclamation, vous disposez du droit de saisir la CNIL.</div></div><div><br></div><p></p>',
                    customMessage:
                        "Si vous souffrez d'allergies alimentaires ou si vous suivez un régime alimentaire spécifique veuillez en aviser directement le restaurant avant de passer votre commande.",
                    emailCustomMessage: null,
                    moduleOrderingFlowId: 881,
                    created_at: '2021-06-14T09:31:30.000Z',
                    updated_at: '2021-06-14T12:38:03.000Z',
                    ewalletPaymentActivated: true,
                    stripePaymentActivated: false,
                    adminCode: '0000',
                    isAlcoolBannerActivated: false,
                    isEwalletReloadButtonHidden: false,
                    isWeborderingButtonHidden: false,
                    isDeliveryEnabled: true,
                    isProductDisplayedWhenUnavailable: true,
                    isRegistrationEnabled: true,
                    isLoginEnabled: false,
                    isNFCLoginEnabled: false,
                    loginStrategy: 3,
                    authenticationEwalletCondition: false,
                    nfcCardStrategy: 'MIFARE_UID',
                    allowAuthAndUnauthOnKiosk: false,
                    JWTSecretKey: 'your-256-bit-secret2',
                    timechefWebhookOrderPushEnabled: false,
                    forceOnlinePaymentForTakeAway: false,
                    isCNTRELuncheonVoucherDeclared: false,
                    isTakeAwayEnabled: true,
                    isSitInEnabled: true,
                    serviceCharge: 0,
                    takeAwayReduction: 1000,
                    rushDelay: 0,
                    openAt: '2021-06-14T11:38:03.000Z',
                    kioskCssUrl: null,
                    is_enabled: true,
                    moduleId: 2,
                    brandId: null,
                    restaurantId: 689,
                    channelId: 2,
                    kioskCount: 0,
                    confirmationMessage: null,
                    confirmationTime: 6000,
                    surveyUrl: '',
                    blindCarbonCopy: '',
                    isCustomCopyEmailEnabled: false,
                    customCopyEmailSubject: '',
                    customCopyEmailTemplate: '',
                    enableCustomerEmail: true,
                    useRegistrationConditions: false,
                    onlinePaymentDiscount: null,
                    invoiceDownloadEnabled: true,
                    afterOrderReturnButtonText: null,
                    afterOrderReturnButtonLink: null,
                    orderFinalValidation: false,
                    useGTMCookiePolicyAsDefault: false,
                },
            ],
            pickupSchedule: [
                {
                    pickupScheduleId: 16716,
                    day: 'MON',
                    start: 540,
                    end: 1380,
                    brandId: null,
                    restaurantId: 689,
                    created_at: '2021-06-17T15:40:52.000Z',
                    updated_at: '2021-06-17T15:40:52.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 16717,
                    day: 'TUE',
                    start: 540,
                    end: 1380,
                    brandId: null,
                    restaurantId: 689,
                    created_at: '2021-06-17T15:40:52.000Z',
                    updated_at: '2021-06-17T15:40:52.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 16718,
                    day: 'WED',
                    start: 540,
                    end: 1380,
                    brandId: null,
                    restaurantId: 689,
                    created_at: '2021-06-17T15:40:52.000Z',
                    updated_at: '2021-06-17T15:40:52.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 16719,
                    day: 'THU',
                    start: 540,
                    end: 1380,
                    brandId: null,
                    restaurantId: 689,
                    created_at: '2021-06-17T15:40:52.000Z',
                    updated_at: '2021-06-17T15:40:52.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 16720,
                    day: 'FRI',
                    start: 540,
                    end: 1380,
                    brandId: null,
                    restaurantId: 689,
                    created_at: '2021-06-17T15:40:52.000Z',
                    updated_at: '2021-06-17T15:40:52.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 16721,
                    day: 'SAT',
                    start: 540,
                    end: 1380,
                    brandId: null,
                    restaurantId: 689,
                    created_at: '2021-06-17T15:40:52.000Z',
                    updated_at: '2021-06-17T15:40:52.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 16722,
                    day: 'SUN',
                    start: 540,
                    end: 1380,
                    brandId: null,
                    restaurantId: 689,
                    created_at: '2021-06-17T15:40:52.000Z',
                    updated_at: '2021-06-17T15:40:52.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
            ],
            moduleOrderingSchedules: [
                {
                    moduleOrderingScheduleId: 551,
                    created_at: '2021-06-14T09:31:31.000Z',
                    updated_at: '2021-06-14T09:31:31.000Z',
                    is_enabled: true,
                    moduleId: 8,
                    brandId: null,
                    restaurantId: 689,
                    channelId: 2,
                    isPreorderingEnabled: true,
                    weborderingSchedules: [
                        {
                            weborderingScheduleId: 4724,
                            day: 'MON',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 551,
                            created_at: '2021-06-14T09:31:31.000Z',
                            updated_at: '2021-06-14T09:31:31.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4725,
                            day: 'MON',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 551,
                            created_at: '2021-06-14T09:31:31.000Z',
                            updated_at: '2021-06-14T09:31:31.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4726,
                            day: 'TUE',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 551,
                            created_at: '2021-06-14T09:31:31.000Z',
                            updated_at: '2021-06-14T09:31:31.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4727,
                            day: 'WED',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 551,
                            created_at: '2021-06-14T09:31:31.000Z',
                            updated_at: '2021-06-14T09:31:31.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4728,
                            day: 'THU',
                            start: 540,
                            end: 600,
                            moduleOrderingScheduleId: 551,
                            created_at: '2021-06-14T09:31:31.000Z',
                            updated_at: '2021-06-14T09:31:31.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4729,
                            day: 'THU',
                            start: 600,
                            end: 840,
                            moduleOrderingScheduleId: 551,
                            created_at: '2021-06-14T09:31:31.000Z',
                            updated_at: '2021-06-14T09:31:31.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4730,
                            day: 'FRI',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 551,
                            created_at: '2021-06-14T09:31:31.000Z',
                            updated_at: '2021-06-14T09:31:31.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4731,
                            day: 'MON',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 551,
                            created_at: '2021-06-14T09:31:31.000Z',
                            updated_at: '2021-06-14T09:31:31.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4732,
                            day: 'TUE',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 551,
                            created_at: '2021-06-14T09:31:31.000Z',
                            updated_at: '2021-06-14T09:31:31.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4733,
                            day: 'TUE',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 551,
                            created_at: '2021-06-14T09:31:31.000Z',
                            updated_at: '2021-06-14T09:31:31.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4734,
                            day: 'WED',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 551,
                            created_at: '2021-06-14T09:31:31.000Z',
                            updated_at: '2021-06-14T09:31:31.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4735,
                            day: 'WED',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 551,
                            created_at: '2021-06-14T09:31:31.000Z',
                            updated_at: '2021-06-14T09:31:31.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4736,
                            day: 'THU',
                            start: 840,
                            end: 1080,
                            moduleOrderingScheduleId: 551,
                            created_at: '2021-06-14T09:31:31.000Z',
                            updated_at: '2021-06-14T09:31:31.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4737,
                            day: 'FRI',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 551,
                            created_at: '2021-06-14T09:31:31.000Z',
                            updated_at: '2021-06-14T09:31:31.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4738,
                            day: 'SAT',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 551,
                            created_at: '2021-06-14T09:31:31.000Z',
                            updated_at: '2021-06-14T09:31:31.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4739,
                            day: 'THU',
                            start: 1080,
                            end: 1320,
                            moduleOrderingScheduleId: 551,
                            created_at: '2021-06-14T09:31:31.000Z',
                            updated_at: '2021-06-14T09:31:31.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4740,
                            day: 'FRI',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 551,
                            created_at: '2021-06-14T09:31:31.000Z',
                            updated_at: '2021-06-14T09:31:31.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4741,
                            day: 'SAT',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 551,
                            created_at: '2021-06-14T09:31:31.000Z',
                            updated_at: '2021-06-14T09:31:31.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4742,
                            day: 'FRI',
                            start: 1260,
                            end: 1425,
                            moduleOrderingScheduleId: 551,
                            created_at: '2021-06-14T09:31:31.000Z',
                            updated_at: '2021-06-14T09:31:31.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4743,
                            day: 'SAT',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 551,
                            created_at: '2021-06-14T09:31:31.000Z',
                            updated_at: '2021-06-14T09:31:31.000Z',
                            is_enabled: true,
                        },
                    ],
                },
            ],
            menus: [
                {
                    menuId: 2900,
                    is_enabled: true,
                    name: 'El Menou',
                    hasInitModalBeenShowed: false,
                    restaurantId: 689,
                    brandId: null,
                    created_at: '2021-06-14T10:22:42.000Z',
                    updated_at: '2021-06-14T10:22:42.000Z',
                    channels: [
                        {
                            channelId: 2,
                            name: 'web',
                            canBeBlocked: true,
                            is_enabled: true,
                            isReportSource: true,
                            created_at: '2017-01-30T01:11:12.000Z',
                            updated_at: '2017-01-30T01:11:12.000Z',
                            menu_channel: {
                                channelId: 2,
                                menuId: 2900,
                                created_at: '2021-06-14T10:22:42.000Z',
                                updated_at: '2021-06-14T10:22:42.000Z',
                            },
                        },
                    ],
                },
            ],
            channels: [
                {
                    channelId: 2,
                    name: 'web',
                    canBeBlocked: true,
                    is_enabled: true,
                    isReportSource: true,
                    created_at: '2017-01-30T01:11:12.000Z',
                    updated_at: '2017-01-30T01:11:12.000Z',
                    restaurant_channel: {
                        restaurantId: 689,
                        channelId: 2,
                        created_at: '2021-06-14T09:31:30.000Z',
                        updated_at: '2021-06-14T09:31:30.000Z',
                    },
                },
            ],
            moduleStripe: {
                moduleStripeId: 66,
                label: 'El Jose Bove Stripe',
                isCNTRELuncheonVoucherDeclared: false,
                stripeUserId: 'acct_1J2ExRDWcqiiaf04',
                stripePublishableKey:
                    'pk_test_51J2ExRDWcqiiaf04PbquhVsOkAuL8aEMDBWMVrNfXa0ObGknv4NkHFU4IKgFpaW2BhjMvVGv5mj2DCmdkkWlfClt00nndIr4Nf',
                liveMode: false,
                isActivated: true,
                stateConnect: null,
                brandId: 10,
                created_at: '2021-06-14T10:19:28.000Z',
                updated_at: '2021-06-14T12:32:02.000Z',
                deleted_at: null,
            },
            consumptionModes: [
                {
                    consumptionModeId: 295,
                    type: 'MODE_DELIVERY',
                    flags: 2,
                    fee: 0,
                    labelFee: null,
                    reduction: 0,
                    labelReduction: null,
                    delay: 0,
                    moduleStripeId: null,
                    stuartId: null,
                    moduleIngenicoId: null,
                    restaurantId: 689,
                    brandId: 10,
                    channelId: 2,
                    isTimeSlotModeEnabled: false,
                    additionalInformationType: null,
                    additionalInformationTitle: null,
                    additionalInformationAllowSkip: false,
                    additionalInformationValueIfSkipped: null,
                    customerShowUpNotification: false,
                    sendReminderEmailShowUpNotification: false,
                    delayBeforeSendingReminderEmailShowUpNotification: 30,
                    created_at: '2021-06-14T09:32:06.000Z',
                    updated_at: '2021-06-14T12:25:12.000Z',
                    deleted_at: null,
                },
                {
                    consumptionModeId: 296,
                    type: 'MODE_TAKE_AWAY',
                    flags: 2,
                    fee: 0,
                    labelFee: null,
                    reduction: 0,
                    labelReduction: null,
                    delay: 0,
                    moduleStripeId: null,
                    stuartId: null,
                    moduleIngenicoId: null,
                    restaurantId: 689,
                    brandId: 10,
                    channelId: 2,
                    isTimeSlotModeEnabled: false,
                    additionalInformationType: null,
                    additionalInformationTitle: null,
                    additionalInformationAllowSkip: false,
                    additionalInformationValueIfSkipped: null,
                    customerShowUpNotification: false,
                    sendReminderEmailShowUpNotification: false,
                    delayBeforeSendingReminderEmailShowUpNotification: 30,
                    created_at: '2021-06-14T09:32:06.000Z',
                    updated_at: '2021-06-14T09:32:28.000Z',
                    deleted_at: null,
                },
                {
                    consumptionModeId: 297,
                    type: 'MODE_SIT_IN',
                    flags: 2,
                    fee: 0,
                    labelFee: null,
                    reduction: 0,
                    labelReduction: null,
                    delay: 0,
                    moduleStripeId: null,
                    stuartId: null,
                    moduleIngenicoId: null,
                    restaurantId: 689,
                    brandId: 10,
                    channelId: 2,
                    isTimeSlotModeEnabled: false,
                    additionalInformationType: null,
                    additionalInformationTitle: null,
                    additionalInformationAllowSkip: false,
                    additionalInformationValueIfSkipped: null,
                    customerShowUpNotification: false,
                    sendReminderEmailShowUpNotification: false,
                    delayBeforeSendingReminderEmailShowUpNotification: 30,
                    created_at: '2021-06-14T09:32:07.000Z',
                    updated_at: '2021-06-14T12:25:23.000Z',
                    deleted_at: null,
                },
                {
                    consumptionModeId: 298,
                    type: 'MODE_DRIVE',
                    flags: 1,
                    fee: 0,
                    labelFee: null,
                    reduction: 0,
                    labelReduction: null,
                    delay: 0,
                    moduleStripeId: null,
                    stuartId: null,
                    moduleIngenicoId: null,
                    restaurantId: 689,
                    brandId: 10,
                    channelId: 2,
                    isTimeSlotModeEnabled: false,
                    additionalInformationType: null,
                    additionalInformationTitle: null,
                    additionalInformationAllowSkip: false,
                    additionalInformationValueIfSkipped: null,
                    customerShowUpNotification: false,
                    sendReminderEmailShowUpNotification: false,
                    delayBeforeSendingReminderEmailShowUpNotification: 30,
                    created_at: '2021-06-14T09:32:07.000Z',
                    updated_at: '2021-06-14T09:32:07.000Z',
                    deleted_at: null,
                },
            ],
            moduleLoyaltyRoyalties: [],
            address: {
                addressId: 1860,
                lat: 49.0074923,
                lng: 2.2077826,
                timeZoneId: 'Europe/Paris',
                locality: 'Taverny',
                route: 'Rue des Lilas',
                postalCode: '95150',
                streetNumber: '18',
                administrativeAreaLevel1: 'Île-de-France',
                administrativeAreaLevel2: "Val-d'Oise",
                country: 'France',
                googlePlaceId: '',
                providerId: 'ChIJowXcAE9n5kcRci4UvrBFXsw',
                phone: null,
                additionalInfo: null,
                digiCode: null,
                apartmentNumber: null,
                iconIdentifier: null,
                customerId: null,
                name: '18 Rue des Lilas, 95150 Taverny, France',
                created_at: '2021-06-14T09:31:27.000Z',
                updated_at: '2021-06-14T09:41:42.000Z',
                deleted_at: null,
            },
        },
        {
            restaurantId: 749,
            name: 'Test NY',
            delayTakeAway: null,
            phoneIndicator: null,
            contactPhone: '0780034421',
            contactName: 'Quentin',
            contactEmail: 'blabla@gmail.com',
            brandId: 10,
            addressId: 1925,
            locale: 'en-GB',
            kitchenDisplayId: null,
            currency: 'EUR',
            created_at: '2021-09-21T13:33:17.000Z',
            updated_at: '2021-10-09T18:56:11.000Z',
            is_enabled: true,
            legalId: 105,
            ewalletMinimumForScanTray: null,
            moduleStripeId: null,
            modulePaygreenId: null,
            moduleSplioId: null,
            moduleApetizPlusId: null,
            externalId: null,
            moduleNeptingId: null,
            lastShiftClosureHour: null,
            module_ordering_flows: [
                {
                    termsAndConditions: null,
                    termsOfUse: null,
                    legalNotice: null,
                    registrationConditions:
                        '<div><div>Vous allez <a href="http://google.fr">communiquer</a> vos données à caractère personnel dans le cadre de la création de votre compte qui vous permet de commander en ligne et de bénéficier d’offres et d’avantages sur les produits proposés par les restaurants de l’enseigne Poivre Rouge. Les champs marqués d’un astérisque doivent être renseignés obligatoirement pour valider votre inscription. A défaut, votre demande d’inscription ne sera pas prise en compte. Vos données à caractère personnel sont collectées à des fins de traitement de vos commandes en lignes, la réalisation d’actions de fidélisation ainsi qu’à des fins de prospection commerciale. Les traitements de données à caractère personnel mentionnés sont juridiquement basés sur votre consentement et l’exécution du contrat conclu avec ITM RESTAURATION. Le responsable de traitement est ITM RESTAURATION, située 3 allée des Mousquetaires. ITM RESTAURATION peut recourir à des sous-traitants. Les destinataires de vos données personnelles sont les restaurants portant l’enseigne Poivre Rouge.</div><div>Les données collectées sont conservées, par défaut, pour une durée de trois ans à compter de leur collecte ou, le cas échéant, de votre dernière connexion à votre compte puis supprimées. ITM RESTAURATION conserve ces données pour une durée plus importante lorsque les obligations légales et réglementaires l’imposent.</div><div>Conformément au Règlement général pour la protection des données n°2016/679 et à la loi dite « Informatique et libertés » du 6 janvier 1978 dans sa dernière version, vous disposez d’un droit d’accès, de rectification, d’effacement des données à caractère personnel qui vous concernent, d’un droit à la limitation du traitement, d’un droit d’opposition, d’un droit à la portabilité de vos données et du droit de définir des directives relatives à la conservation, à l\'effacement et à la communication de vos données à caractère personnel après votre décès.</div><div>Vous pouvez exercer vos droits en vous adressant directement par courrier postal au Service Marketing Poivre Rouge 3 Allée des Mousquetaires 91078 Bondoufle Cedex.</div><div>Pour toute autre demande, vous pouvez également contacter le délégué à la protection des données par courriel à l’adresse dpolesmousquetaires@mousquetaires.com</div><div>En cas de réclamation, vous disposez du droit de saisir la CNIL.</div></div><div><br></div><p></p>',
                    customMessage:
                        "Si vous souffrez d'allergies alimentaires ou si vous suivez un régime alimentaire spécifique veuillez en aviser directement le restaurant avant de passer votre commande.",
                    emailCustomMessage: 'TOTO<p></p>',
                    moduleOrderingFlowId: 981,
                    created_at: '2021-09-21T13:33:36.000Z',
                    updated_at: '2021-09-21T13:39:19.000Z',
                    ewalletPaymentActivated: true,
                    stripePaymentActivated: false,
                    adminCode: '0000',
                    isAlcoolBannerActivated: false,
                    isEwalletReloadButtonHidden: true,
                    isWeborderingButtonHidden: false,
                    isDeliveryEnabled: true,
                    isProductDisplayedWhenUnavailable: false,
                    isRegistrationEnabled: true,
                    isLoginEnabled: false,
                    isNFCLoginEnabled: false,
                    loginStrategy: 3,
                    authenticationEwalletCondition: false,
                    nfcCardStrategy: 'MIFARE_UID',
                    allowAuthAndUnauthOnKiosk: false,
                    JWTSecretKey: 'your-256-bit-secret2',
                    timechefWebhookOrderPushEnabled: false,
                    forceOnlinePaymentForTakeAway: false,
                    isCNTRELuncheonVoucherDeclared: false,
                    isTakeAwayEnabled: true,
                    isSitInEnabled: true,
                    serviceCharge: 0,
                    takeAwayReduction: 1000,
                    rushDelay: 0,
                    openAt: '2021-09-21T12:39:19.000Z',
                    kioskCssUrl: null,
                    is_enabled: true,
                    moduleId: 2,
                    brandId: null,
                    restaurantId: 749,
                    channelId: 2,
                    kioskCount: 0,
                    confirmationMessage: null,
                    confirmationTime: 6000,
                    surveyUrl: null,
                    blindCarbonCopy: null,
                    isCustomCopyEmailEnabled: false,
                    customCopyEmailSubject: null,
                    customCopyEmailTemplate: null,
                    enableCustomerEmail: true,
                    useRegistrationConditions: false,
                    onlinePaymentDiscount: null,
                    invoiceDownloadEnabled: true,
                    afterOrderReturnButtonText: null,
                    afterOrderReturnButtonLink: null,
                    orderFinalValidation: false,
                    useGTMCookiePolicyAsDefault: false,
                },
            ],
            pickupSchedule: [
                {
                    pickupScheduleId: 18911,
                    day: 'MON',
                    start: 540,
                    end: 780,
                    brandId: null,
                    restaurantId: 749,
                    created_at: '2021-10-27T14:38:50.000Z',
                    updated_at: '2021-10-27T14:38:50.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 18912,
                    day: 'TUE',
                    start: 540,
                    end: 780,
                    brandId: null,
                    restaurantId: 749,
                    created_at: '2021-10-27T14:38:50.000Z',
                    updated_at: '2021-10-27T14:38:50.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 18913,
                    day: 'WED',
                    start: 540,
                    end: 1140,
                    brandId: null,
                    restaurantId: 749,
                    created_at: '2021-10-27T14:38:50.000Z',
                    updated_at: '2021-10-27T14:38:50.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 18914,
                    day: 'THU',
                    start: 540,
                    end: 1140,
                    brandId: null,
                    restaurantId: 749,
                    created_at: '2021-10-27T14:38:50.000Z',
                    updated_at: '2021-10-27T14:38:50.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 18915,
                    day: 'FRI',
                    start: 540,
                    end: 1140,
                    brandId: null,
                    restaurantId: 749,
                    created_at: '2021-10-27T14:38:50.000Z',
                    updated_at: '2021-10-27T14:38:50.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 18916,
                    day: 'SAT',
                    start: 540,
                    end: 780,
                    brandId: null,
                    restaurantId: 749,
                    created_at: '2021-10-27T14:38:51.000Z',
                    updated_at: '2021-10-27T14:38:51.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 18917,
                    day: 'SUN',
                    start: 540,
                    end: 780,
                    brandId: null,
                    restaurantId: 749,
                    created_at: '2021-10-27T14:38:51.000Z',
                    updated_at: '2021-10-27T14:38:51.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
            ],
            moduleOrderingSchedules: [
                {
                    moduleOrderingScheduleId: 607,
                    created_at: '2021-09-21T13:33:37.000Z',
                    updated_at: '2021-09-21T13:33:37.000Z',
                    is_enabled: true,
                    moduleId: 8,
                    brandId: null,
                    restaurantId: 749,
                    channelId: 2,
                    isPreorderingEnabled: true,
                    weborderingSchedules: [
                        {
                            weborderingScheduleId: 5600,
                            day: 'MON',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 607,
                            created_at: '2021-09-21T13:33:37.000Z',
                            updated_at: '2021-09-21T13:33:37.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5601,
                            day: 'MON',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 607,
                            created_at: '2021-09-21T13:33:37.000Z',
                            updated_at: '2021-09-21T13:33:37.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5602,
                            day: 'TUE',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 607,
                            created_at: '2021-09-21T13:33:37.000Z',
                            updated_at: '2021-09-21T13:33:37.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5603,
                            day: 'WED',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 607,
                            created_at: '2021-09-21T13:33:37.000Z',
                            updated_at: '2021-09-21T13:33:37.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5604,
                            day: 'THU',
                            start: 540,
                            end: 600,
                            moduleOrderingScheduleId: 607,
                            created_at: '2021-09-21T13:33:37.000Z',
                            updated_at: '2021-09-21T13:33:37.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5605,
                            day: 'THU',
                            start: 600,
                            end: 840,
                            moduleOrderingScheduleId: 607,
                            created_at: '2021-09-21T13:33:37.000Z',
                            updated_at: '2021-09-21T13:33:37.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5606,
                            day: 'FRI',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 607,
                            created_at: '2021-09-21T13:33:37.000Z',
                            updated_at: '2021-09-21T13:33:37.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5607,
                            day: 'MON',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 607,
                            created_at: '2021-09-21T13:33:37.000Z',
                            updated_at: '2021-09-21T13:33:37.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5608,
                            day: 'TUE',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 607,
                            created_at: '2021-09-21T13:33:37.000Z',
                            updated_at: '2021-09-21T13:33:37.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5609,
                            day: 'TUE',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 607,
                            created_at: '2021-09-21T13:33:37.000Z',
                            updated_at: '2021-09-21T13:33:37.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5610,
                            day: 'WED',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 607,
                            created_at: '2021-09-21T13:33:37.000Z',
                            updated_at: '2021-09-21T13:33:37.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5611,
                            day: 'WED',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 607,
                            created_at: '2021-09-21T13:33:37.000Z',
                            updated_at: '2021-09-21T13:33:37.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5612,
                            day: 'THU',
                            start: 840,
                            end: 1080,
                            moduleOrderingScheduleId: 607,
                            created_at: '2021-09-21T13:33:37.000Z',
                            updated_at: '2021-09-21T13:33:37.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5613,
                            day: 'FRI',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 607,
                            created_at: '2021-09-21T13:33:37.000Z',
                            updated_at: '2021-09-21T13:33:37.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5614,
                            day: 'SAT',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 607,
                            created_at: '2021-09-21T13:33:37.000Z',
                            updated_at: '2021-09-21T13:33:37.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5615,
                            day: 'THU',
                            start: 1080,
                            end: 1320,
                            moduleOrderingScheduleId: 607,
                            created_at: '2021-09-21T13:33:37.000Z',
                            updated_at: '2021-09-21T13:33:37.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5616,
                            day: 'FRI',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 607,
                            created_at: '2021-09-21T13:33:37.000Z',
                            updated_at: '2021-09-21T13:33:37.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5617,
                            day: 'SAT',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 607,
                            created_at: '2021-09-21T13:33:37.000Z',
                            updated_at: '2021-09-21T13:33:37.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5618,
                            day: 'FRI',
                            start: 1260,
                            end: 1425,
                            moduleOrderingScheduleId: 607,
                            created_at: '2021-09-21T13:33:37.000Z',
                            updated_at: '2021-09-21T13:33:37.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5619,
                            day: 'SAT',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 607,
                            created_at: '2021-09-21T13:33:37.000Z',
                            updated_at: '2021-09-21T13:33:37.000Z',
                            is_enabled: true,
                        },
                    ],
                },
            ],
            menus: [
                {
                    menuId: 3045,
                    is_enabled: true,
                    name: 'catalogue-abdel-test',
                    hasInitModalBeenShowed: false,
                    restaurantId: 749,
                    brandId: null,
                    created_at: '2021-09-21T13:33:31.000Z',
                    updated_at: '2021-09-21T13:33:31.000Z',
                    channels: [
                        {
                            channelId: 2,
                            name: 'web',
                            canBeBlocked: true,
                            is_enabled: true,
                            isReportSource: true,
                            created_at: '2017-01-30T01:11:12.000Z',
                            updated_at: '2017-01-30T01:11:12.000Z',
                            menu_channel: {
                                channelId: 2,
                                menuId: 3045,
                                created_at: '2021-10-27T14:34:52.000Z',
                                updated_at: '2021-10-27T14:34:52.000Z',
                            },
                        },
                    ],
                },
            ],
            channels: [
                {
                    channelId: 2,
                    name: 'web',
                    canBeBlocked: true,
                    is_enabled: true,
                    isReportSource: true,
                    created_at: '2017-01-30T01:11:12.000Z',
                    updated_at: '2017-01-30T01:11:12.000Z',
                    restaurant_channel: {
                        restaurantId: 749,
                        channelId: 2,
                        created_at: '2021-09-21T13:33:36.000Z',
                        updated_at: '2021-09-21T13:33:36.000Z',
                    },
                },
            ],
            moduleStripe: null,
            consumptionModes: [
                {
                    consumptionModeId: 321,
                    type: 'MODE_TAKE_AWAY',
                    flags: 0,
                    fee: 0,
                    labelFee: null,
                    reduction: 0,
                    labelReduction: null,
                    delay: 0,
                    moduleStripeId: null,
                    stuartId: null,
                    moduleIngenicoId: null,
                    restaurantId: 749,
                    brandId: 10,
                    channelId: 2,
                    isTimeSlotModeEnabled: false,
                    additionalInformationType: null,
                    additionalInformationTitle: null,
                    additionalInformationAllowSkip: false,
                    additionalInformationValueIfSkipped: null,
                    customerShowUpNotification: false,
                    sendReminderEmailShowUpNotification: false,
                    delayBeforeSendingReminderEmailShowUpNotification: 30,
                    created_at: '2021-09-21T13:34:23.000Z',
                    updated_at: '2021-10-27T14:36:12.000Z',
                    deleted_at: null,
                },
            ],
            moduleLoyaltyRoyalties: [],
            address: {
                addressId: 1925,
                lat: 48.8689168,
                lng: 2.3527634,
                timeZoneId: 'Europe/Paris',
                locality: 'Paris',
                route: 'Rue Blondel',
                postalCode: '75002',
                streetNumber: '30',
                administrativeAreaLevel1: 'Île-de-France',
                administrativeAreaLevel2: 'Département de Paris',
                country: 'France',
                googlePlaceId: '',
                providerId: 'ChIJkzIxGRFu5kcRliBS_bQYIts',
                phone: null,
                additionalInfo: null,
                digiCode: null,
                apartmentNumber: null,
                iconIdentifier: null,
                customerId: null,
                name: '30 Rue Blondel, 75002 Paris, France',
                created_at: '2021-09-21T13:33:17.000Z',
                updated_at: '2021-10-27T14:31:09.000Z',
                deleted_at: null,
            },
        },
        {
            restaurantId: 778,
            name: 'RestoHgouillard',
            delayTakeAway: null,
            phoneIndicator: null,
            contactPhone: '0102030405',
            contactName: 'Hubert Gouillard',
            contactEmail: 'resto-hg@innovorder.fr',
            brandId: 10,
            addressId: 1970,
            locale: 'fr',
            kitchenDisplayId: null,
            currency: 'EUR',
            created_at: '2022-02-02T09:21:57.000Z',
            updated_at: '2022-02-02T10:06:15.000Z',
            is_enabled: true,
            legalId: 113,
            ewalletMinimumForScanTray: null,
            moduleStripeId: null,
            modulePaygreenId: null,
            moduleSplioId: null,
            moduleApetizPlusId: null,
            externalId: null,
            moduleNeptingId: null,
            lastShiftClosureHour: null,
            module_ordering_flows: [
                {
                    termsAndConditions: null,
                    termsOfUse: null,
                    legalNotice: null,
                    registrationConditions:
                        '<div><div>Vous allez <a href="http://google.fr">communiquer</a> vos données à caractère personnel dans le cadre de la création de votre compte qui vous permet de commander en ligne et de bénéficier d’offres et d’avantages sur les produits proposés par les restaurants de l’enseigne Poivre Rouge. Les champs marqués d’un astérisque doivent être renseignés obligatoirement pour valider votre inscription. A défaut, votre demande d’inscription ne sera pas prise en compte. Vos données à caractère personnel sont collectées à des fins de traitement de vos commandes en lignes, la réalisation d’actions de fidélisation ainsi qu’à des fins de prospection commerciale. Les traitements de données à caractère personnel mentionnés sont juridiquement basés sur votre consentement et l’exécution du contrat conclu avec ITM RESTAURATION. Le responsable de traitement est ITM RESTAURATION, située 3 allée des Mousquetaires. ITM RESTAURATION peut recourir à des sous-traitants. Les destinataires de vos données personnelles sont les restaurants portant l’enseigne Poivre Rouge.</div><div>Les données collectées sont conservées, par défaut, pour une durée de trois ans à compter de leur collecte ou, le cas échéant, de votre dernière connexion à votre compte puis supprimées. ITM RESTAURATION conserve ces données pour une durée plus importante lorsque les obligations légales et réglementaires l’imposent.</div><div>Conformément au Règlement général pour la protection des données n°2016/679 et à la loi dite « Informatique et libertés » du 6 janvier 1978 dans sa dernière version, vous disposez d’un droit d’accès, de rectification, d’effacement des données à caractère personnel qui vous concernent, d’un droit à la limitation du traitement, d’un droit d’opposition, d’un droit à la portabilité de vos données et du droit de définir des directives relatives à la conservation, à l\'effacement et à la communication de vos données à caractère personnel après votre décès.</div><div>Vous pouvez exercer vos droits en vous adressant directement par courrier postal au Service Marketing Poivre Rouge 3 Allée des Mousquetaires 91078 Bondoufle Cedex.</div><div>Pour toute autre demande, vous pouvez également contacter le délégué à la protection des données par courriel à l’adresse dpolesmousquetaires@mousquetaires.com</div><div>En cas de réclamation, vous disposez du droit de saisir la CNIL.</div></div><div><br></div><p></p>',
                    customMessage:
                        "Si vous souffrez d'allergies alimentaires ou si vous suivez un régime alimentaire spécifique veuillez en aviser directement le restaurant avant de passer votre commande.",
                    emailCustomMessage: 'TOTO<p></p>',
                    moduleOrderingFlowId: 1046,
                    created_at: '2022-02-02T09:22:01.000Z',
                    updated_at: '2022-02-02T09:23:14.000Z',
                    ewalletPaymentActivated: true,
                    stripePaymentActivated: false,
                    adminCode: '0000',
                    isAlcoolBannerActivated: false,
                    isEwalletReloadButtonHidden: true,
                    isWeborderingButtonHidden: false,
                    isDeliveryEnabled: true,
                    isProductDisplayedWhenUnavailable: false,
                    isRegistrationEnabled: true,
                    isLoginEnabled: false,
                    isNFCLoginEnabled: false,
                    loginStrategy: 3,
                    authenticationEwalletCondition: false,
                    nfcCardStrategy: 'MIFARE_UID',
                    allowAuthAndUnauthOnKiosk: false,
                    JWTSecretKey: 'your-256-bit-secret2',
                    timechefWebhookOrderPushEnabled: false,
                    forceOnlinePaymentForTakeAway: false,
                    isCNTRELuncheonVoucherDeclared: false,
                    isTakeAwayEnabled: true,
                    isSitInEnabled: true,
                    serviceCharge: 0,
                    takeAwayReduction: 1000,
                    rushDelay: 0,
                    openAt: '2022-02-02T08:23:14.000Z',
                    kioskCssUrl: null,
                    is_enabled: true,
                    moduleId: 2,
                    brandId: null,
                    restaurantId: 778,
                    channelId: 2,
                    kioskCount: 0,
                    confirmationMessage: null,
                    confirmationTime: 6000,
                    surveyUrl: null,
                    blindCarbonCopy: null,
                    isCustomCopyEmailEnabled: false,
                    customCopyEmailSubject: null,
                    customCopyEmailTemplate: null,
                    enableCustomerEmail: true,
                    useRegistrationConditions: false,
                    onlinePaymentDiscount: null,
                    invoiceDownloadEnabled: true,
                    afterOrderReturnButtonText: null,
                    afterOrderReturnButtonLink: null,
                    orderFinalValidation: false,
                    useGTMCookiePolicyAsDefault: false,
                },
            ],
            pickupSchedule: [
                {
                    pickupScheduleId: 19780,
                    day: 'MON',
                    start: 540,
                    end: 1380,
                    brandId: null,
                    restaurantId: 778,
                    created_at: '2022-02-02T09:28:01.000Z',
                    updated_at: '2022-02-02T09:28:01.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 19781,
                    day: 'TUE',
                    start: 540,
                    end: 1380,
                    brandId: null,
                    restaurantId: 778,
                    created_at: '2022-02-02T09:28:01.000Z',
                    updated_at: '2022-02-02T09:28:01.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 19782,
                    day: 'WED',
                    start: 540,
                    end: 780,
                    brandId: null,
                    restaurantId: 778,
                    created_at: '2022-02-02T09:28:01.000Z',
                    updated_at: '2022-02-02T09:28:01.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 19783,
                    day: 'WED',
                    start: 780,
                    end: 1020,
                    brandId: null,
                    restaurantId: 778,
                    created_at: '2022-02-02T09:28:01.000Z',
                    updated_at: '2022-02-02T09:28:01.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 19784,
                    day: 'WED',
                    start: 1020,
                    end: 1380,
                    brandId: null,
                    restaurantId: 778,
                    created_at: '2022-02-02T09:28:01.000Z',
                    updated_at: '2022-02-02T09:28:01.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 19785,
                    day: 'THU',
                    start: 540,
                    end: 1380,
                    brandId: null,
                    restaurantId: 778,
                    created_at: '2022-02-02T09:28:01.000Z',
                    updated_at: '2022-02-02T09:28:01.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 19786,
                    day: 'FRI',
                    start: 540,
                    end: 1380,
                    brandId: null,
                    restaurantId: 778,
                    created_at: '2022-02-02T09:28:01.000Z',
                    updated_at: '2022-02-02T09:28:01.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 19787,
                    day: 'SAT',
                    start: 780,
                    end: 960,
                    brandId: null,
                    restaurantId: 778,
                    created_at: '2022-02-02T09:28:01.000Z',
                    updated_at: '2022-02-02T09:28:01.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 19788,
                    day: 'SAT',
                    start: 540,
                    end: 780,
                    brandId: null,
                    restaurantId: 778,
                    created_at: '2022-02-02T09:28:01.000Z',
                    updated_at: '2022-02-02T09:28:01.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 19789,
                    day: 'SAT',
                    start: 960,
                    end: 1200,
                    brandId: null,
                    restaurantId: 778,
                    created_at: '2022-02-02T09:28:02.000Z',
                    updated_at: '2022-02-02T09:28:02.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 19790,
                    day: 'SUN',
                    start: 720,
                    end: 1020,
                    brandId: null,
                    restaurantId: 778,
                    created_at: '2022-02-02T09:28:02.000Z',
                    updated_at: '2022-02-02T09:28:02.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 19791,
                    day: 'SUN',
                    start: 1020,
                    end: 1260,
                    brandId: null,
                    restaurantId: 778,
                    created_at: '2022-02-02T09:28:02.000Z',
                    updated_at: '2022-02-02T09:28:02.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
            ],
            moduleOrderingSchedules: [
                {
                    moduleOrderingScheduleId: 644,
                    created_at: '2022-02-02T09:22:01.000Z',
                    updated_at: '2022-02-02T09:22:01.000Z',
                    is_enabled: true,
                    moduleId: 8,
                    brandId: null,
                    restaurantId: 778,
                    channelId: 2,
                    isPreorderingEnabled: true,
                    weborderingSchedules: [
                        {
                            weborderingScheduleId: 5966,
                            day: 'MON',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 644,
                            created_at: '2022-02-02T09:22:01.000Z',
                            updated_at: '2022-02-02T09:22:01.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5967,
                            day: 'MON',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 644,
                            created_at: '2022-02-02T09:22:01.000Z',
                            updated_at: '2022-02-02T09:22:01.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5968,
                            day: 'TUE',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 644,
                            created_at: '2022-02-02T09:22:01.000Z',
                            updated_at: '2022-02-02T09:22:01.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5969,
                            day: 'WED',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 644,
                            created_at: '2022-02-02T09:22:01.000Z',
                            updated_at: '2022-02-02T09:22:01.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5970,
                            day: 'THU',
                            start: 540,
                            end: 600,
                            moduleOrderingScheduleId: 644,
                            created_at: '2022-02-02T09:22:01.000Z',
                            updated_at: '2022-02-02T09:22:01.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5971,
                            day: 'THU',
                            start: 600,
                            end: 840,
                            moduleOrderingScheduleId: 644,
                            created_at: '2022-02-02T09:22:01.000Z',
                            updated_at: '2022-02-02T09:22:01.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5972,
                            day: 'FRI',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 644,
                            created_at: '2022-02-02T09:22:01.000Z',
                            updated_at: '2022-02-02T09:22:01.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5973,
                            day: 'MON',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 644,
                            created_at: '2022-02-02T09:22:01.000Z',
                            updated_at: '2022-02-02T09:22:01.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5974,
                            day: 'TUE',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 644,
                            created_at: '2022-02-02T09:22:01.000Z',
                            updated_at: '2022-02-02T09:22:01.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5975,
                            day: 'TUE',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 644,
                            created_at: '2022-02-02T09:22:01.000Z',
                            updated_at: '2022-02-02T09:22:01.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5976,
                            day: 'WED',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 644,
                            created_at: '2022-02-02T09:22:01.000Z',
                            updated_at: '2022-02-02T09:22:01.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5977,
                            day: 'WED',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 644,
                            created_at: '2022-02-02T09:22:01.000Z',
                            updated_at: '2022-02-02T09:22:01.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5978,
                            day: 'THU',
                            start: 840,
                            end: 1080,
                            moduleOrderingScheduleId: 644,
                            created_at: '2022-02-02T09:22:01.000Z',
                            updated_at: '2022-02-02T09:22:01.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5979,
                            day: 'FRI',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 644,
                            created_at: '2022-02-02T09:22:01.000Z',
                            updated_at: '2022-02-02T09:22:01.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5980,
                            day: 'SAT',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 644,
                            created_at: '2022-02-02T09:22:01.000Z',
                            updated_at: '2022-02-02T09:22:01.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5981,
                            day: 'THU',
                            start: 1080,
                            end: 1320,
                            moduleOrderingScheduleId: 644,
                            created_at: '2022-02-02T09:22:01.000Z',
                            updated_at: '2022-02-02T09:22:01.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5982,
                            day: 'FRI',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 644,
                            created_at: '2022-02-02T09:22:01.000Z',
                            updated_at: '2022-02-02T09:22:01.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5983,
                            day: 'SAT',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 644,
                            created_at: '2022-02-02T09:22:01.000Z',
                            updated_at: '2022-02-02T09:22:01.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5984,
                            day: 'FRI',
                            start: 1260,
                            end: 1425,
                            moduleOrderingScheduleId: 644,
                            created_at: '2022-02-02T09:22:01.000Z',
                            updated_at: '2022-02-02T09:22:01.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 5985,
                            day: 'SAT',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 644,
                            created_at: '2022-02-02T09:22:01.000Z',
                            updated_at: '2022-02-02T09:22:01.000Z',
                            is_enabled: true,
                        },
                    ],
                },
            ],
            menus: [
                {
                    menuId: 3889,
                    is_enabled: true,
                    name: 'MENU_UBEREATS',
                    hasInitModalBeenShowed: false,
                    restaurantId: 778,
                    brandId: null,
                    created_at: '2022-02-02T09:21:58.000Z',
                    updated_at: '2022-02-02T09:21:58.000Z',
                    channels: [
                        {
                            channelId: 2,
                            name: 'web',
                            canBeBlocked: true,
                            is_enabled: true,
                            isReportSource: true,
                            created_at: '2017-01-30T01:11:12.000Z',
                            updated_at: '2017-01-30T01:11:12.000Z',
                            menu_channel: {
                                channelId: 2,
                                menuId: 3889,
                                created_at: '2022-02-02T09:24:08.000Z',
                                updated_at: '2022-02-02T09:24:08.000Z',
                            },
                        },
                    ],
                },
            ],
            channels: [
                {
                    channelId: 2,
                    name: 'web',
                    canBeBlocked: true,
                    is_enabled: true,
                    isReportSource: true,
                    created_at: '2017-01-30T01:11:12.000Z',
                    updated_at: '2017-01-30T01:11:12.000Z',
                    restaurant_channel: {
                        restaurantId: 778,
                        channelId: 2,
                        created_at: '2022-02-02T09:22:01.000Z',
                        updated_at: '2022-02-02T09:22:01.000Z',
                    },
                },
            ],
            moduleStripe: null,
            consumptionModes: [
                {
                    consumptionModeId: 353,
                    type: 'MODE_TAKE_AWAY',
                    flags: 2,
                    fee: 0,
                    labelFee: null,
                    reduction: 0,
                    labelReduction: null,
                    delay: 0,
                    moduleStripeId: null,
                    stuartId: null,
                    moduleIngenicoId: null,
                    restaurantId: 778,
                    brandId: 10,
                    channelId: 2,
                    isTimeSlotModeEnabled: false,
                    additionalInformationType: null,
                    additionalInformationTitle: null,
                    additionalInformationAllowSkip: false,
                    additionalInformationValueIfSkipped: null,
                    customerShowUpNotification: false,
                    sendReminderEmailShowUpNotification: false,
                    delayBeforeSendingReminderEmailShowUpNotification: 30,
                    created_at: '2022-02-02T09:24:53.000Z',
                    updated_at: '2022-02-02T09:27:51.000Z',
                    deleted_at: null,
                },
                {
                    consumptionModeId: 354,
                    type: 'MODE_SIT_IN',
                    flags: 2,
                    fee: 0,
                    labelFee: null,
                    reduction: 0,
                    labelReduction: null,
                    delay: 0,
                    moduleStripeId: null,
                    stuartId: null,
                    moduleIngenicoId: null,
                    restaurantId: 778,
                    brandId: 10,
                    channelId: 2,
                    isTimeSlotModeEnabled: false,
                    additionalInformationType: null,
                    additionalInformationTitle: null,
                    additionalInformationAllowSkip: false,
                    additionalInformationValueIfSkipped: null,
                    customerShowUpNotification: false,
                    sendReminderEmailShowUpNotification: false,
                    delayBeforeSendingReminderEmailShowUpNotification: 30,
                    created_at: '2022-02-02T09:24:55.000Z',
                    updated_at: '2022-02-02T09:28:01.000Z',
                    deleted_at: null,
                },
            ],
            moduleLoyaltyRoyalties: [],
            address: {
                addressId: 1970,
                lat: 48.8720216,
                lng: 2.3500933,
                timeZoneId: 'Europe/Paris',
                locality: 'Paris',
                route: "Rue d'Hauteville",
                postalCode: '75010',
                streetNumber: '18',
                administrativeAreaLevel1: 'Île-de-France',
                administrativeAreaLevel2: 'Département de Paris',
                country: 'France',
                googlePlaceId: '',
                providerId: 'ChIJ_zKMFxRu5kcRodEkFbH_XA8',
                phone: null,
                additionalInfo: null,
                digiCode: null,
                apartmentNumber: null,
                iconIdentifier: null,
                customerId: null,
                name: "18 Rue d'Hauteville, 75010 Paris, France",
                created_at: '2022-02-02T09:21:57.000Z',
                updated_at: '2022-02-02T09:21:58.000Z',
                deleted_at: null,
            },
        },
        {
            restaurantId: 255,
            name: 'Banc de dev',
            delayTakeAway: null,
            phoneIndicator: null,
            contactPhone: '000000000',
            contactName: '_',
            contactEmail: 'test@test.fr',
            brandId: 10,
            addressId: 1462,
            locale: 'fr',
            kitchenDisplayId: 18,
            currency: 'EUR',
            created_at: '2020-04-30T13:42:11.000Z',
            updated_at: '2022-03-01T08:51:52.000Z',
            is_enabled: true,
            legalId: 56,
            ewalletMinimumForScanTray: 2000,
            moduleStripeId: 17,
            modulePaygreenId: 10,
            moduleSplioId: null,
            moduleApetizPlusId: 7,
            externalId: null,
            moduleNeptingId: 6,
            lastShiftClosureHour: null,
            module_ordering_flows: [
                {
                    termsAndConditions: null,
                    termsOfUse: null,
                    legalNotice: null,
                    registrationConditions:
                        "<div><div>Vous allez communiquer vos données à caractère personnel dans le cadre de la création de votre compte qui vous permet de commander en ligne et de bénéficier d’offres et d’avantages sur les produits proposés par les restaurants de l’enseigne Poivre Rouge. Les champs marqués d’un astérisque doivent être renseignés obligatoirement pour valider votre inscription. A défaut, votre demande d’inscription ne sera pas prise en compte. Vos données à caractère personnel sont collectées à des fins de traitement de vos commandes en lignes, la réalisation d’actions de fidélisation ainsi qu’à des fins de prospection commerciale. Les traitements de données à caractère personnel mentionnés sont juridiquement basés sur votre consentement et l’exécution du contrat conclu avec ITM RESTAURATION. Le responsable de traitement est ITM RESTAURATION, située 3 allée des Mousquetaires. ITM RESTAURATION peut recourir à des sous-traitants. Les destinataires de vos données personnelles sont les restaurants portant l’enseigne Poivre Rouge.</div><div>Les données collectées sont conservées, par défaut, pour une durée de trois ans à compter de leur collecte ou, le cas échéant, de votre dernière connexion à votre compte puis supprimées. ITM RESTAURATION conserve ces données pour une durée plus importante lorsque les obligations légales et réglementaires l’imposent.</div><div>Conformément au Règlement général pour la protection des données n°2016/679 et à la loi dite « Informatique et libertés » du 6 janvier 1978 dans sa dernière version, vous disposez d’un droit d’accès, de rectification, d’effacement des données à caractère personnel qui vous concernent, d’un droit à la limitation du traitement, d’un droit d’opposition, d’un droit à la portabilité de vos données et du droit de définir des directives relatives à la conservation, à l'effacement et à la communication de vos données à caractère personnel après votre décès.</div><div>Vous pouvez exercer vos droits en vous adressant directement par courrier postal au Service Marketing Poivre Rouge 3 Allée des Mousquetaires 91078 Bondoufle Cedex.</div><div>Pour toute autre demande, vous pouvez également contacter le délégué à la protection des données par courriel à l’adresse dpolesmousquetaires@mousquetaires.com</div><div>En cas de réclamation, vous disposez du droit de saisir la CNIL.</div></div><p></p>",
                    customMessage:
                        "Si vous souffrez d'allergies alimentaires ou si vous suivez un régime alimentaire spécifique veuillez en aviser directement le restaurant avant de passer votre commande.",
                    emailCustomMessage: 'TOTO<p></p>',
                    moduleOrderingFlowId: 452,
                    created_at: '2020-04-30T13:58:55.000Z',
                    updated_at: '2021-09-22T12:52:20.000Z',
                    ewalletPaymentActivated: true,
                    stripePaymentActivated: false,
                    adminCode: '0000',
                    isAlcoolBannerActivated: false,
                    isEwalletReloadButtonHidden: false,
                    isWeborderingButtonHidden: false,
                    isDeliveryEnabled: true,
                    isProductDisplayedWhenUnavailable: false,
                    isRegistrationEnabled: true,
                    isLoginEnabled: false,
                    isNFCLoginEnabled: false,
                    loginStrategy: 3,
                    authenticationEwalletCondition: false,
                    nfcCardStrategy: 'MIFARE_UID',
                    allowAuthAndUnauthOnKiosk: false,
                    JWTSecretKey: 'your-256-bit-secret2',
                    timechefWebhookOrderPushEnabled: false,
                    forceOnlinePaymentForTakeAway: false,
                    isCNTRELuncheonVoucherDeclared: false,
                    isTakeAwayEnabled: true,
                    isSitInEnabled: true,
                    serviceCharge: 0,
                    takeAwayReduction: 1000,
                    rushDelay: 0,
                    openAt: '2020-07-23T07:13:40.000Z',
                    kioskCssUrl: null,
                    is_enabled: true,
                    moduleId: 2,
                    brandId: null,
                    restaurantId: 255,
                    channelId: 2,
                    kioskCount: 0,
                    confirmationMessage: null,
                    confirmationTime: 6000,
                    surveyUrl: '',
                    blindCarbonCopy: 'yanncherif@live.fr',
                    isCustomCopyEmailEnabled: false,
                    customCopyEmailSubject: '',
                    customCopyEmailTemplate: '',
                    enableCustomerEmail: true,
                    useRegistrationConditions: false,
                    onlinePaymentDiscount: null,
                    invoiceDownloadEnabled: true,
                    afterOrderReturnButtonText: null,
                    afterOrderReturnButtonLink: null,
                    orderFinalValidation: false,
                    useGTMCookiePolicyAsDefault: false,
                },
            ],
            pickupSchedule: [
                {
                    pickupScheduleId: 14908,
                    day: 'THU',
                    start: 300,
                    end: 780,
                    brandId: null,
                    restaurantId: 255,
                    created_at: '2021-02-08T16:44:10.000Z',
                    updated_at: '2021-02-08T16:44:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 14909,
                    day: 'MON',
                    start: 300,
                    end: 780,
                    brandId: null,
                    restaurantId: 255,
                    created_at: '2021-02-08T16:44:10.000Z',
                    updated_at: '2021-02-08T16:44:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 14910,
                    day: 'SAT',
                    start: 300,
                    end: 780,
                    brandId: null,
                    restaurantId: 255,
                    created_at: '2021-02-08T16:44:10.000Z',
                    updated_at: '2021-02-08T16:44:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 14911,
                    day: 'FRI',
                    start: 300,
                    end: 780,
                    brandId: null,
                    restaurantId: 255,
                    created_at: '2021-02-08T16:44:10.000Z',
                    updated_at: '2021-02-08T16:44:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 14912,
                    day: 'TUE',
                    start: 300,
                    end: 780,
                    brandId: null,
                    restaurantId: 255,
                    created_at: '2021-02-08T16:44:10.000Z',
                    updated_at: '2021-02-08T16:44:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 14913,
                    day: 'WED',
                    start: 300,
                    end: 780,
                    brandId: null,
                    restaurantId: 255,
                    created_at: '2021-02-08T16:44:10.000Z',
                    updated_at: '2021-02-08T16:44:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 14914,
                    day: 'SAT',
                    start: 780,
                    end: 960,
                    brandId: null,
                    restaurantId: 255,
                    created_at: '2021-02-08T16:44:10.000Z',
                    updated_at: '2021-02-08T16:44:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 14915,
                    day: 'THU',
                    start: 1020,
                    end: 1260,
                    brandId: null,
                    restaurantId: 255,
                    created_at: '2021-02-08T16:44:10.000Z',
                    updated_at: '2021-02-08T16:44:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 14916,
                    day: 'TUE',
                    start: 780,
                    end: 1020,
                    brandId: null,
                    restaurantId: 255,
                    created_at: '2021-02-08T16:44:10.000Z',
                    updated_at: '2021-02-08T16:44:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 14917,
                    day: 'THU',
                    start: 780,
                    end: 1020,
                    brandId: null,
                    restaurantId: 255,
                    created_at: '2021-02-08T16:44:10.000Z',
                    updated_at: '2021-02-08T16:44:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 14918,
                    day: 'MON',
                    start: 780,
                    end: 1020,
                    brandId: null,
                    restaurantId: 255,
                    created_at: '2021-02-08T16:44:10.000Z',
                    updated_at: '2021-02-08T16:44:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 14919,
                    day: 'SUN',
                    start: 720,
                    end: 1020,
                    brandId: null,
                    restaurantId: 255,
                    created_at: '2021-02-08T16:44:10.000Z',
                    updated_at: '2021-02-08T16:44:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 14920,
                    day: 'SUN',
                    start: 1020,
                    end: 1260,
                    brandId: null,
                    restaurantId: 255,
                    created_at: '2021-02-08T16:44:10.000Z',
                    updated_at: '2021-02-08T16:44:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 14921,
                    day: 'FRI',
                    start: 780,
                    end: 1020,
                    brandId: null,
                    restaurantId: 255,
                    created_at: '2021-02-08T16:44:10.000Z',
                    updated_at: '2021-02-08T16:44:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 14922,
                    day: 'WED',
                    start: 780,
                    end: 1020,
                    brandId: null,
                    restaurantId: 255,
                    created_at: '2021-02-08T16:44:10.000Z',
                    updated_at: '2021-02-08T16:44:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 14923,
                    day: 'MON',
                    start: 1020,
                    end: 1260,
                    brandId: null,
                    restaurantId: 255,
                    created_at: '2021-02-08T16:44:10.000Z',
                    updated_at: '2021-02-08T16:44:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 14924,
                    day: 'TUE',
                    start: 1020,
                    end: 1260,
                    brandId: null,
                    restaurantId: 255,
                    created_at: '2021-02-08T16:44:10.000Z',
                    updated_at: '2021-02-08T16:44:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 14925,
                    day: 'SAT',
                    start: 960,
                    end: 1200,
                    brandId: null,
                    restaurantId: 255,
                    created_at: '2021-02-08T16:44:10.000Z',
                    updated_at: '2021-02-08T16:44:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 14926,
                    day: 'WED',
                    start: 1020,
                    end: 1260,
                    brandId: null,
                    restaurantId: 255,
                    created_at: '2021-02-08T16:44:10.000Z',
                    updated_at: '2021-02-08T16:44:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 14927,
                    day: 'FRI',
                    start: 1020,
                    end: 1260,
                    brandId: null,
                    restaurantId: 255,
                    created_at: '2021-02-08T16:44:10.000Z',
                    updated_at: '2021-02-08T16:44:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 14928,
                    day: 'FRI',
                    start: 1260,
                    end: 1425,
                    brandId: null,
                    restaurantId: 255,
                    created_at: '2021-02-08T16:44:10.000Z',
                    updated_at: '2021-02-08T16:44:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
            ],
            moduleOrderingSchedules: [
                {
                    moduleOrderingScheduleId: 298,
                    created_at: '2020-04-30T13:58:56.000Z',
                    updated_at: '2021-05-27T06:07:33.000Z',
                    is_enabled: true,
                    moduleId: 8,
                    brandId: null,
                    restaurantId: 255,
                    channelId: 2,
                    isPreorderingEnabled: true,
                    weborderingSchedules: [
                        {
                            weborderingScheduleId: 4648,
                            day: 'MON',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 298,
                            created_at: '2021-05-27T06:07:33.000Z',
                            updated_at: '2021-05-27T06:07:33.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4649,
                            day: 'MON',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 298,
                            created_at: '2021-05-27T06:07:33.000Z',
                            updated_at: '2021-05-27T06:07:33.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4650,
                            day: 'TUE',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 298,
                            created_at: '2021-05-27T06:07:33.000Z',
                            updated_at: '2021-05-27T06:07:33.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4651,
                            day: 'WED',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 298,
                            created_at: '2021-05-27T06:07:33.000Z',
                            updated_at: '2021-05-27T06:07:33.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4652,
                            day: 'THU',
                            start: 540,
                            end: 600,
                            moduleOrderingScheduleId: 298,
                            created_at: '2021-05-27T06:07:33.000Z',
                            updated_at: '2021-05-27T06:07:33.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4653,
                            day: 'THU',
                            start: 600,
                            end: 720,
                            moduleOrderingScheduleId: 298,
                            created_at: '2021-05-27T06:07:33.000Z',
                            updated_at: '2021-05-27T06:07:33.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4654,
                            day: 'FRI',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 298,
                            created_at: '2021-05-27T06:07:33.000Z',
                            updated_at: '2021-05-27T06:07:33.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4655,
                            day: 'MON',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 298,
                            created_at: '2021-05-27T06:07:33.000Z',
                            updated_at: '2021-05-27T06:07:33.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4656,
                            day: 'TUE',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 298,
                            created_at: '2021-05-27T06:07:33.000Z',
                            updated_at: '2021-05-27T06:07:33.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4657,
                            day: 'TUE',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 298,
                            created_at: '2021-05-27T06:07:33.000Z',
                            updated_at: '2021-05-27T06:07:33.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4658,
                            day: 'WED',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 298,
                            created_at: '2021-05-27T06:07:33.000Z',
                            updated_at: '2021-05-27T06:07:33.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4659,
                            day: 'WED',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 298,
                            created_at: '2021-05-27T06:07:33.000Z',
                            updated_at: '2021-05-27T06:07:33.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4660,
                            day: 'THU',
                            start: 900,
                            end: 1080,
                            moduleOrderingScheduleId: 298,
                            created_at: '2021-05-27T06:07:33.000Z',
                            updated_at: '2021-05-27T06:07:33.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4661,
                            day: 'FRI',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 298,
                            created_at: '2021-05-27T06:07:33.000Z',
                            updated_at: '2021-05-27T06:07:33.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4662,
                            day: 'SAT',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 298,
                            created_at: '2021-05-27T06:07:33.000Z',
                            updated_at: '2021-05-27T06:07:33.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4663,
                            day: 'THU',
                            start: 1080,
                            end: 1320,
                            moduleOrderingScheduleId: 298,
                            created_at: '2021-05-27T06:07:33.000Z',
                            updated_at: '2021-05-27T06:07:33.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4664,
                            day: 'FRI',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 298,
                            created_at: '2021-05-27T06:07:33.000Z',
                            updated_at: '2021-05-27T06:07:33.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4665,
                            day: 'SAT',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 298,
                            created_at: '2021-05-27T06:07:33.000Z',
                            updated_at: '2021-05-27T06:07:33.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4666,
                            day: 'FRI',
                            start: 1260,
                            end: 1425,
                            moduleOrderingScheduleId: 298,
                            created_at: '2021-05-27T06:07:33.000Z',
                            updated_at: '2021-05-27T06:07:33.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 4667,
                            day: 'SAT',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 298,
                            created_at: '2021-05-27T06:07:33.000Z',
                            updated_at: '2021-05-27T06:07:33.000Z',
                            is_enabled: true,
                        },
                    ],
                },
            ],
            menus: [
                {
                    menuId: 3987,
                    is_enabled: true,
                    name: 'showroom',
                    hasInitModalBeenShowed: false,
                    restaurantId: 255,
                    brandId: null,
                    created_at: '2022-03-09T10:08:26.000Z',
                    updated_at: '2022-03-09T10:08:26.000Z',
                    channels: [
                        {
                            channelId: 2,
                            name: 'web',
                            canBeBlocked: true,
                            is_enabled: true,
                            isReportSource: true,
                            created_at: '2017-01-30T01:11:12.000Z',
                            updated_at: '2017-01-30T01:11:12.000Z',
                            menu_channel: {
                                channelId: 2,
                                menuId: 3987,
                                created_at: '2022-06-06T13:33:21.000Z',
                                updated_at: '2022-06-06T13:33:21.000Z',
                            },
                        },
                    ],
                },
            ],
            channels: [
                {
                    channelId: 2,
                    name: 'web',
                    canBeBlocked: true,
                    is_enabled: true,
                    isReportSource: true,
                    created_at: '2017-01-30T01:11:12.000Z',
                    updated_at: '2017-01-30T01:11:12.000Z',
                    restaurant_channel: {
                        restaurantId: 255,
                        channelId: 2,
                        created_at: '2020-04-30T13:58:55.000Z',
                        updated_at: '2020-04-30T13:58:55.000Z',
                    },
                },
            ],
            moduleStripe: {
                moduleStripeId: 17,
                label: "Eat'n'drink Stripe",
                isCNTRELuncheonVoucherDeclared: false,
                stripeUserId: 'acct_1KTNUXFscUAPoZMJ',
                stripePublishableKey:
                    'pk_test_51KTNUXFscUAPoZMJ36xNbGicJoltoCMjOSBDhYqjQ3tPTVCnnBqrn03HKbbsVqgIrEeOKl2tLYIl8Nmtbo8vqmoM00054wkYxN',
                liveMode: false,
                isActivated: true,
                stateConnect: null,
                brandId: 10,
                created_at: '2017-09-01T10:08:27.000Z',
                updated_at: '2022-02-15T09:38:39.000Z',
                deleted_at: null,
            },
            consumptionModes: [
                {
                    consumptionModeId: 237,
                    type: 'MODE_DELIVERY',
                    flags: 0,
                    fee: 0,
                    labelFee: null,
                    reduction: 0,
                    labelReduction: null,
                    delay: 0,
                    moduleStripeId: null,
                    stuartId: null,
                    moduleIngenicoId: null,
                    restaurantId: 255,
                    brandId: 10,
                    channelId: 2,
                    isTimeSlotModeEnabled: false,
                    additionalInformationType: null,
                    additionalInformationTitle: null,
                    additionalInformationAllowSkip: null,
                    additionalInformationValueIfSkipped: null,
                    customerShowUpNotification: false,
                    sendReminderEmailShowUpNotification: false,
                    delayBeforeSendingReminderEmailShowUpNotification: 30,
                    created_at: '2020-07-22T15:50:54.000Z',
                    updated_at: '2020-12-01T13:21:32.000Z',
                    deleted_at: null,
                },
                {
                    consumptionModeId: 238,
                    type: 'MODE_TAKE_AWAY',
                    flags: 6,
                    fee: 0,
                    labelFee: null,
                    reduction: 0,
                    labelReduction: null,
                    delay: 0,
                    moduleStripeId: null,
                    stuartId: null,
                    moduleIngenicoId: null,
                    restaurantId: 255,
                    brandId: 10,
                    channelId: 2,
                    isTimeSlotModeEnabled: false,
                    additionalInformationType: null,
                    additionalInformationTitle: null,
                    additionalInformationAllowSkip: null,
                    additionalInformationValueIfSkipped: null,
                    customerShowUpNotification: true,
                    sendReminderEmailShowUpNotification: true,
                    delayBeforeSendingReminderEmailShowUpNotification: 10,
                    created_at: '2020-07-22T15:50:54.000Z',
                    updated_at: '2020-12-04T13:32:05.000Z',
                    deleted_at: null,
                },
            ],
            moduleLoyaltyRoyalties: [],
            address: {
                addressId: 1462,
                lat: 48.872791,
                lng: 2.35031,
                timeZoneId: 'Europe/Paris',
                locality: 'Paris',
                route: "Rue D'hauteville",
                postalCode: '75010',
                streetNumber: '28',
                administrativeAreaLevel1: '',
                administrativeAreaLevel2: '10th arrondissement of Paris',
                country: 'fr',
                googlePlaceId: '',
                providerId: 'address.8747740568982268',
                phone: null,
                additionalInfo: null,
                digiCode: null,
                apartmentNumber: null,
                iconIdentifier: null,
                customerId: null,
                name: "28 Rue D'hauteville, 75010 Paris, France",
                created_at: '2020-04-30T13:42:11.000Z',
                updated_at: '2020-07-22T14:10:49.000Z',
                deleted_at: null,
            },
        },
        {
            restaurantId: 44,
            name: 'Big Fernandd',
            delayTakeAway: null,
            phoneIndicator: null,
            contactPhone: '0123456789',
            contactName: 'DQ',
            contactEmail: 'test@test.Fr',
            brandId: 10,
            addressId: 993,
            locale: 'fr',
            kitchenDisplayId: 19,
            currency: 'EUR',
            created_at: '2017-10-04T13:41:10.000Z',
            updated_at: '2022-04-01T09:32:23.000Z',
            is_enabled: true,
            legalId: 59,
            ewalletMinimumForScanTray: null,
            moduleStripeId: 20,
            modulePaygreenId: 1,
            moduleSplioId: 25,
            moduleApetizPlusId: null,
            externalId: '048161',
            moduleNeptingId: 5,
            lastShiftClosureHour: '00:01',
            module_ordering_flows: [
                {
                    termsAndConditions: null,
                    termsOfUse: null,
                    legalNotice: null,
                    registrationConditions: null,
                    customMessage: null,
                    emailCustomMessage: null,
                    moduleOrderingFlowId: 96,
                    created_at: '2017-10-04T13:41:44.000Z',
                    updated_at: '2018-04-10T14:34:43.000Z',
                    ewalletPaymentActivated: true,
                    stripePaymentActivated: false,
                    adminCode: '0000',
                    isAlcoolBannerActivated: false,
                    isEwalletReloadButtonHidden: false,
                    isWeborderingButtonHidden: false,
                    isDeliveryEnabled: true,
                    isProductDisplayedWhenUnavailable: false,
                    isRegistrationEnabled: true,
                    isLoginEnabled: false,
                    isNFCLoginEnabled: false,
                    loginStrategy: 3,
                    authenticationEwalletCondition: false,
                    nfcCardStrategy: 'MIFARE_UID',
                    allowAuthAndUnauthOnKiosk: false,
                    JWTSecretKey: null,
                    timechefWebhookOrderPushEnabled: false,
                    forceOnlinePaymentForTakeAway: false,
                    isCNTRELuncheonVoucherDeclared: false,
                    isTakeAwayEnabled: true,
                    isSitInEnabled: true,
                    serviceCharge: 0,
                    takeAwayReduction: 1000,
                    rushDelay: 0,
                    openAt: '2017-01-31T16:27:14.000Z',
                    kioskCssUrl: null,
                    is_enabled: true,
                    moduleId: 2,
                    brandId: null,
                    restaurantId: 44,
                    channelId: 2,
                    kioskCount: 0,
                    confirmationMessage: null,
                    confirmationTime: 6000,
                    surveyUrl: null,
                    blindCarbonCopy: null,
                    isCustomCopyEmailEnabled: false,
                    customCopyEmailSubject: null,
                    customCopyEmailTemplate: null,
                    enableCustomerEmail: true,
                    useRegistrationConditions: false,
                    onlinePaymentDiscount: null,
                    invoiceDownloadEnabled: true,
                    afterOrderReturnButtonText: null,
                    afterOrderReturnButtonLink: null,
                    orderFinalValidation: false,
                    useGTMCookiePolicyAsDefault: false,
                },
            ],
            pickupSchedule: [
                {
                    pickupScheduleId: 20146,
                    day: 'MON',
                    start: 540,
                    end: 780,
                    brandId: null,
                    restaurantId: 44,
                    created_at: '2022-05-19T08:32:01.000Z',
                    updated_at: '2022-05-19T08:32:01.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20147,
                    day: 'TUE',
                    start: 615,
                    end: 645,
                    brandId: null,
                    restaurantId: 44,
                    created_at: '2022-05-19T08:32:01.000Z',
                    updated_at: '2022-05-19T08:32:01.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20148,
                    day: 'TUE',
                    start: 600,
                    end: 615,
                    brandId: null,
                    restaurantId: 44,
                    created_at: '2022-05-19T08:32:01.000Z',
                    updated_at: '2022-05-19T08:32:01.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20149,
                    day: 'TUE',
                    start: 645,
                    end: 675,
                    brandId: null,
                    restaurantId: 44,
                    created_at: '2022-05-19T08:32:01.000Z',
                    updated_at: '2022-05-19T08:32:01.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20150,
                    day: 'TUE',
                    start: 675,
                    end: 705,
                    brandId: null,
                    restaurantId: 44,
                    created_at: '2022-05-19T08:32:02.000Z',
                    updated_at: '2022-05-19T08:32:02.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20151,
                    day: 'TUE',
                    start: 705,
                    end: 735,
                    brandId: null,
                    restaurantId: 44,
                    created_at: '2022-05-19T08:32:02.000Z',
                    updated_at: '2022-05-19T08:32:02.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20152,
                    day: 'MON',
                    start: 780,
                    end: 1020,
                    brandId: null,
                    restaurantId: 44,
                    created_at: '2022-05-19T08:32:02.000Z',
                    updated_at: '2022-05-19T08:32:02.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20153,
                    day: 'WED',
                    start: 540,
                    end: 780,
                    brandId: null,
                    restaurantId: 44,
                    created_at: '2022-05-19T08:32:02.000Z',
                    updated_at: '2022-05-19T08:32:02.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20154,
                    day: 'FRI',
                    start: 780,
                    end: 1020,
                    brandId: null,
                    restaurantId: 44,
                    created_at: '2022-05-19T08:32:02.000Z',
                    updated_at: '2022-05-19T08:32:02.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20155,
                    day: 'FRI',
                    start: 540,
                    end: 780,
                    brandId: null,
                    restaurantId: 44,
                    created_at: '2022-05-19T08:32:02.000Z',
                    updated_at: '2022-05-19T08:32:02.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20156,
                    day: 'MON',
                    start: 1080,
                    end: 1140,
                    brandId: null,
                    restaurantId: 44,
                    created_at: '2022-05-19T08:32:02.000Z',
                    updated_at: '2022-05-19T08:32:02.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20157,
                    day: 'MON',
                    start: 1140,
                    end: 1170,
                    brandId: null,
                    restaurantId: 44,
                    created_at: '2022-05-19T08:32:02.000Z',
                    updated_at: '2022-05-19T08:32:02.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20158,
                    day: 'MON',
                    start: 1170,
                    end: 1200,
                    brandId: null,
                    restaurantId: 44,
                    created_at: '2022-05-19T08:32:02.000Z',
                    updated_at: '2022-05-19T08:32:02.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20159,
                    day: 'MON',
                    start: 1200,
                    end: 1425,
                    brandId: null,
                    restaurantId: 44,
                    created_at: '2022-05-19T08:32:02.000Z',
                    updated_at: '2022-05-19T08:32:02.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20160,
                    day: 'TUE',
                    start: 735,
                    end: 1260,
                    brandId: null,
                    restaurantId: 44,
                    created_at: '2022-05-19T08:32:02.000Z',
                    updated_at: '2022-05-19T08:32:02.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20161,
                    day: 'WED',
                    start: 780,
                    end: 1380,
                    brandId: null,
                    restaurantId: 44,
                    created_at: '2022-05-19T08:32:02.000Z',
                    updated_at: '2022-05-19T08:32:02.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20162,
                    day: 'THU',
                    start: 540,
                    end: 1380,
                    brandId: null,
                    restaurantId: 44,
                    created_at: '2022-05-19T08:32:02.000Z',
                    updated_at: '2022-05-19T08:32:02.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
            ],
            moduleOrderingSchedules: [
                {
                    moduleOrderingScheduleId: 61,
                    created_at: '2017-10-04T13:41:44.000Z',
                    updated_at: '2018-04-10T14:34:43.000Z',
                    is_enabled: true,
                    moduleId: 8,
                    brandId: null,
                    restaurantId: 44,
                    channelId: 2,
                    isPreorderingEnabled: true,
                    weborderingSchedules: [],
                },
            ],
            menus: [
                {
                    menuId: 4115,
                    is_enabled: true,
                    name: 'helios-menu-2022-04-12',
                    hasInitModalBeenShowed: false,
                    restaurantId: 44,
                    brandId: null,
                    created_at: '2022-04-11T10:58:37.000Z',
                    updated_at: '2022-04-11T10:58:37.000Z',
                    channels: [
                        {
                            channelId: 2,
                            name: 'web',
                            canBeBlocked: true,
                            is_enabled: true,
                            isReportSource: true,
                            created_at: '2017-01-30T01:11:12.000Z',
                            updated_at: '2017-01-30T01:11:12.000Z',
                            menu_channel: {
                                channelId: 2,
                                menuId: 4115,
                                created_at: '2022-04-11T10:59:18.000Z',
                                updated_at: '2022-04-11T10:59:18.000Z',
                            },
                        },
                    ],
                },
            ],
            channels: [
                {
                    channelId: 2,
                    name: 'web',
                    canBeBlocked: true,
                    is_enabled: true,
                    isReportSource: true,
                    created_at: '2017-01-30T01:11:12.000Z',
                    updated_at: '2017-01-30T01:11:12.000Z',
                    restaurant_channel: {
                        restaurantId: 44,
                        channelId: 2,
                        created_at: '2018-04-10T14:34:43.000Z',
                        updated_at: '2018-04-10T14:34:43.000Z',
                    },
                },
            ],
            moduleStripe: {
                moduleStripeId: 20,
                label: 'test Stripe',
                isCNTRELuncheonVoucherDeclared: true,
                stripeUserId: 'acct_1B9W6mIaebui1x3L',
                stripePublishableKey: 'pk_test_xvxrFmijzSM30z7dn18IH6Dy',
                liveMode: false,
                isActivated: true,
                stateConnect: null,
                brandId: 10,
                created_at: '2017-10-05T09:57:32.000Z',
                updated_at: '2017-10-05T10:06:01.000Z',
                deleted_at: null,
            },
            consumptionModes: [
                {
                    consumptionModeId: 80,
                    type: 'MODE_DELIVERY',
                    flags: 2,
                    fee: 100,
                    labelFee: null,
                    reduction: 0,
                    labelReduction: null,
                    delay: 0,
                    moduleStripeId: null,
                    stuartId: null,
                    moduleIngenicoId: null,
                    restaurantId: 44,
                    brandId: 10,
                    channelId: 2,
                    isTimeSlotModeEnabled: false,
                    additionalInformationType: null,
                    additionalInformationTitle: null,
                    additionalInformationAllowSkip: null,
                    additionalInformationValueIfSkipped: null,
                    customerShowUpNotification: false,
                    sendReminderEmailShowUpNotification: false,
                    delayBeforeSendingReminderEmailShowUpNotification: 30,
                    created_at: '2017-10-05T14:55:47.000Z',
                    updated_at: '2022-03-10T15:15:09.000Z',
                    deleted_at: null,
                },
                {
                    consumptionModeId: 81,
                    type: 'MODE_TAKE_AWAY',
                    flags: 2,
                    fee: 0,
                    labelFee: null,
                    reduction: 0,
                    labelReduction: null,
                    delay: 0,
                    moduleStripeId: null,
                    stuartId: null,
                    moduleIngenicoId: null,
                    restaurantId: 44,
                    brandId: 10,
                    channelId: 2,
                    isTimeSlotModeEnabled: false,
                    additionalInformationType: null,
                    additionalInformationTitle: null,
                    additionalInformationAllowSkip: null,
                    additionalInformationValueIfSkipped: null,
                    customerShowUpNotification: false,
                    sendReminderEmailShowUpNotification: false,
                    delayBeforeSendingReminderEmailShowUpNotification: 30,
                    created_at: '2017-10-05T14:55:48.000Z',
                    updated_at: '2021-10-28T16:52:35.000Z',
                    deleted_at: null,
                },
                {
                    consumptionModeId: 82,
                    type: 'MODE_DRIVE',
                    flags: 3,
                    fee: 0,
                    labelFee: null,
                    reduction: 0,
                    labelReduction: null,
                    delay: 0,
                    moduleStripeId: null,
                    stuartId: null,
                    moduleIngenicoId: null,
                    restaurantId: 44,
                    brandId: 10,
                    channelId: 2,
                    isTimeSlotModeEnabled: false,
                    additionalInformationType: null,
                    additionalInformationTitle: null,
                    additionalInformationAllowSkip: null,
                    additionalInformationValueIfSkipped: null,
                    customerShowUpNotification: false,
                    sendReminderEmailShowUpNotification: false,
                    delayBeforeSendingReminderEmailShowUpNotification: 30,
                    created_at: '2017-10-05T14:55:49.000Z',
                    updated_at: '2021-10-28T16:52:21.000Z',
                    deleted_at: null,
                },
                {
                    consumptionModeId: 83,
                    type: 'MODE_SIT_IN',
                    flags: 2,
                    fee: 0,
                    labelFee: null,
                    reduction: 0,
                    labelReduction: null,
                    delay: 0,
                    moduleStripeId: null,
                    stuartId: null,
                    moduleIngenicoId: null,
                    restaurantId: 44,
                    brandId: 10,
                    channelId: 2,
                    isTimeSlotModeEnabled: false,
                    additionalInformationType: null,
                    additionalInformationTitle: null,
                    additionalInformationAllowSkip: null,
                    additionalInformationValueIfSkipped: null,
                    customerShowUpNotification: false,
                    sendReminderEmailShowUpNotification: false,
                    delayBeforeSendingReminderEmailShowUpNotification: 30,
                    created_at: '2017-10-05T14:55:49.000Z',
                    updated_at: '2021-10-28T16:52:29.000Z',
                    deleted_at: null,
                },
            ],
            moduleLoyaltyRoyalties: [
                {
                    moduleLoyaltyRoyaltyId: 3,
                    is_enabled: true,
                    percentage: 8000,
                    moduleId: 17,
                    brandId: null,
                    restaurantId: 44,
                    channelId: 6,
                    customCss:
                        '#intro * {\n    margin: 0;\n    padding: 0;\n}\n\n#intro .description {\n    margin-top: 20px;\n    margin-bottom: 50px;\n    width: 80%;\n    text-align: center;\n}\n\n#intro .content-container {\n    width: 100%;\n    padding-bottom: 30px;\n}\n\n#intro .content-container h4 {\n    text-align: center;\n    margin-bottom: 10px;\n}\n\n\n#intro .content-container .perks {\n    background-color: #fdfdfd;\n    border: solid 1px #e2e2e2;\n    padding: 20px 0;\n    width: 100%;\n    margin: 10px 0;\n}\n\n#intro .content-container .perks h5 {\n    font-family: avenir-heavy;\n    text-transform: uppercase;\n}\n\n#intro .content-container .perks i {\n    /*color: $brand-color;*/\n    font-size: 24px;\n}\n\n#intro .content-container .perks p {\n    font-size: 12px;\n}\n    \n#intro .content-container fio-button {\n    /*background-color: $brand-color;*/\n    font-size: 20px;\n    font-family: avenir-heavy;\n    padding: 15px 70px;\n    border-radius: 4px;\n    /*color: $text-on-brand;*/\n    margin-bottom: 20px;\n}',
                    customHtmlMessage:
                        '<div layout="column" layout-align="center center">\n    <p class="description">Grâce à votre carte de fidélité Fresh Burritos, vous cumulez des euros à chacune de vos visites dans nos restaurants ou de vos commandes passées sur notre site internet.</p>\n    <section class="content-container">\n        <h4>Découvrez les avantages de la carte de fidélité</h4>\n        <div class="perks" layout="row" layout-align="space-around center">\n            <i class="icon icon-feed-price"></i>\n            <div flex="80">\n                <h5>5% DE VOTRE NOTE CRÉDITÉ EN AVOIR</h5>\n                <p>sur votre carte à chaque passage en caisse</p>\n            </div>\n        </div>\n        <div class="perks" layout="row" layout-align="space-around center">\n            <i class="icon icon-feed-wallet"></i>\n            <div flex="80">\n                <h5>VOTRE COMPTE FIDÉLITÉ</h5>\n                <p>consultable à tout moment sur internet.</p>\n            </div>\n        </div>\n        <div class="perks" layout="row" layout-align="space-around center">\n            <i class="icon icon-coin-euro"></i>\n            <div flex="80">\n                <h5>VOTRE SOLDE D\'EUROS SAUVEGARDÉ</h5>\n                <p>même en cas de perte de votre carte ! </p>\n            </div>\n        </div>\n    </section>\n</div>\n',
                    created_at: '2017-10-20T10:22:08.000Z',
                    updated_at: '2021-09-27T09:59:57.000Z',
                    deleted_at: null,
                },
            ],
            address: {
                addressId: 993,
                lat: 48.8640152,
                lng: 2.3503204,
                timeZoneId: 'Europe/Paris',
                locality: 'Paris',
                route: 'Rue de Turbigo',
                postalCode: '75002',
                streetNumber: '18',
                administrativeAreaLevel1: 'Île-de-France',
                administrativeAreaLevel2: 'Département de Paris',
                country: 'France',
                googlePlaceId: 'ChIJwRNqpwBy5kcR3MbG0F3jLNQ',
                providerId: 'ChIJrZ0ShBlu5kcRLFkv82Aoea8',
                phone: null,
                additionalInfo: null,
                digiCode: null,
                apartmentNumber: null,
                iconIdentifier: null,
                customerId: null,
                name: '18 R. de Turbigo, 75002 Paris, France',
                created_at: '2017-10-04T13:41:10.000Z',
                updated_at: '2022-06-09T13:08:17.000Z',
                deleted_at: null,
            },
        },
        {
            restaurantId: 791,
            name: 'Quentin - Test paiments',
            delayTakeAway: null,
            phoneIndicator: null,
            contactPhone: null,
            contactName: null,
            contactEmail: null,
            brandId: 10,
            addressId: 1990,
            locale: 'en-GB',
            kitchenDisplayId: null,
            currency: 'EUR',
            created_at: '2022-05-05T12:12:54.000Z',
            updated_at: '2022-05-05T12:12:54.000Z',
            is_enabled: true,
            legalId: null,
            ewalletMinimumForScanTray: null,
            moduleStripeId: null,
            modulePaygreenId: null,
            moduleSplioId: null,
            moduleApetizPlusId: null,
            externalId: null,
            moduleNeptingId: null,
            lastShiftClosureHour: null,
            module_ordering_flows: [
                {
                    termsAndConditions: null,
                    termsOfUse: null,
                    legalNotice: null,
                    registrationConditions:
                        '<div><div>Vous allez <a href="http://google.fr">communiquer</a> vos données à caractère personnel dans le cadre de la création de votre compte qui vous permet de commander en ligne et de bénéficier d’offres et d’avantages sur les produits proposés par les restaurants de l’enseigne Poivre Rouge. Les champs marqués d’un astérisque doivent être renseignés obligatoirement pour valider votre inscription. A défaut, votre demande d’inscription ne sera pas prise en compte. Vos données à caractère personnel sont collectées à des fins de traitement de vos commandes en lignes, la réalisation d’actions de fidélisation ainsi qu’à des fins de prospection commerciale. Les traitements de données à caractère personnel mentionnés sont juridiquement basés sur votre consentement et l’exécution du contrat conclu avec ITM RESTAURATION. Le responsable de traitement est ITM RESTAURATION, située 3 allée des Mousquetaires. ITM RESTAURATION peut recourir à des sous-traitants. Les destinataires de vos données personnelles sont les restaurants portant l’enseigne Poivre Rouge.</div><div>Les données collectées sont conservées, par défaut, pour une durée de trois ans à compter de leur collecte ou, le cas échéant, de votre dernière connexion à votre compte puis supprimées. ITM RESTAURATION conserve ces données pour une durée plus importante lorsque les obligations légales et réglementaires l’imposent.</div><div>Conformément au Règlement général pour la protection des données n°2016/679 et à la loi dite « Informatique et libertés » du 6 janvier 1978 dans sa dernière version, vous disposez d’un droit d’accès, de rectification, d’effacement des données à caractère personnel qui vous concernent, d’un droit à la limitation du traitement, d’un droit d’opposition, d’un droit à la portabilité de vos données et du droit de définir des directives relatives à la conservation, à l\'effacement et à la communication de vos données à caractère personnel après votre décès.</div><div>Vous pouvez exercer vos droits en vous adressant directement par courrier postal au Service Marketing Poivre Rouge 3 Allée des Mousquetaires 91078 Bondoufle Cedex.</div><div>Pour toute autre demande, vous pouvez également contacter le délégué à la protection des données par courriel à l’adresse dpolesmousquetaires@mousquetaires.com</div><div>En cas de réclamation, vous disposez du droit de saisir la CNIL.</div></div><div><br></div><p></p>',
                    customMessage:
                        "si vous souffrez d'allergies alimentaires ou si vous suivez un régime alimentaire spécifique veuillez en aviser directement le restaurant avant de passer votre commande.",
                    emailCustomMessage: 'TOTO<p></p>',
                    moduleOrderingFlowId: 1072,
                    created_at: '2022-05-05T12:15:24.000Z',
                    updated_at: '2022-05-05T12:15:24.000Z',
                    ewalletPaymentActivated: true,
                    stripePaymentActivated: false,
                    adminCode: '0000',
                    isAlcoolBannerActivated: false,
                    isEwalletReloadButtonHidden: true,
                    isWeborderingButtonHidden: false,
                    isDeliveryEnabled: true,
                    isProductDisplayedWhenUnavailable: false,
                    isRegistrationEnabled: true,
                    isLoginEnabled: false,
                    isNFCLoginEnabled: false,
                    loginStrategy: 3,
                    authenticationEwalletCondition: false,
                    nfcCardStrategy: 'MIFARE_UID',
                    allowAuthAndUnauthOnKiosk: false,
                    JWTSecretKey: 'your-256-bit-secret',
                    timechefWebhookOrderPushEnabled: false,
                    forceOnlinePaymentForTakeAway: false,
                    isCNTRELuncheonVoucherDeclared: false,
                    isTakeAwayEnabled: true,
                    isSitInEnabled: true,
                    serviceCharge: 0,
                    takeAwayReduction: 1000,
                    rushDelay: 0,
                    openAt: '3022-05-04T22:00:00.000Z',
                    kioskCssUrl: null,
                    is_enabled: true,
                    moduleId: 2,
                    brandId: null,
                    restaurantId: 791,
                    channelId: 2,
                    kioskCount: 0,
                    confirmationMessage: null,
                    confirmationTime: 6000,
                    surveyUrl: null,
                    blindCarbonCopy: null,
                    isCustomCopyEmailEnabled: false,
                    customCopyEmailSubject: null,
                    customCopyEmailTemplate: null,
                    enableCustomerEmail: true,
                    useRegistrationConditions: false,
                    onlinePaymentDiscount: null,
                    invoiceDownloadEnabled: true,
                    afterOrderReturnButtonText: null,
                    afterOrderReturnButtonLink: null,
                    orderFinalValidation: false,
                    useGTMCookiePolicyAsDefault: false,
                },
            ],
            pickupSchedule: [
                {
                    pickupScheduleId: 20062,
                    day: 'MON',
                    start: 540,
                    end: 780,
                    brandId: null,
                    restaurantId: 791,
                    created_at: '2021-10-01T08:39:02.000Z',
                    updated_at: '2022-05-05T12:15:07.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20063,
                    day: 'MON',
                    start: 780,
                    end: 1020,
                    brandId: null,
                    restaurantId: 791,
                    created_at: '2021-10-01T08:39:02.000Z',
                    updated_at: '2022-05-05T12:15:07.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20064,
                    day: 'MON',
                    start: 1020,
                    end: 1260,
                    brandId: null,
                    restaurantId: 791,
                    created_at: '2021-10-01T08:39:02.000Z',
                    updated_at: '2022-05-05T12:15:08.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20065,
                    day: 'TUE',
                    start: 540,
                    end: 1380,
                    brandId: null,
                    restaurantId: 791,
                    created_at: '2021-10-01T08:39:02.000Z',
                    updated_at: '2022-05-05T12:15:08.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20066,
                    day: 'WED',
                    start: 540,
                    end: 780,
                    brandId: null,
                    restaurantId: 791,
                    created_at: '2021-10-01T08:39:02.000Z',
                    updated_at: '2022-05-05T12:15:08.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20067,
                    day: 'WED',
                    start: 780,
                    end: 1020,
                    brandId: null,
                    restaurantId: 791,
                    created_at: '2021-10-01T08:39:02.000Z',
                    updated_at: '2022-05-05T12:15:08.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20068,
                    day: 'WED',
                    start: 1020,
                    end: 1380,
                    brandId: null,
                    restaurantId: 791,
                    created_at: '2021-10-01T08:39:02.000Z',
                    updated_at: '2022-05-05T12:15:09.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20069,
                    day: 'THU',
                    start: 540,
                    end: 1380,
                    brandId: null,
                    restaurantId: 791,
                    created_at: '2021-10-01T08:39:02.000Z',
                    updated_at: '2022-05-05T12:15:09.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20070,
                    day: 'FRI',
                    start: 540,
                    end: 1380,
                    brandId: null,
                    restaurantId: 791,
                    created_at: '2021-10-01T08:39:02.000Z',
                    updated_at: '2022-05-05T12:15:09.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20071,
                    day: 'SAT',
                    start: 780,
                    end: 960,
                    brandId: null,
                    restaurantId: 791,
                    created_at: '2021-10-01T08:39:02.000Z',
                    updated_at: '2022-05-05T12:15:09.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20072,
                    day: 'SAT',
                    start: 540,
                    end: 780,
                    brandId: null,
                    restaurantId: 791,
                    created_at: '2021-10-01T08:39:02.000Z',
                    updated_at: '2022-05-05T12:15:09.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20073,
                    day: 'SAT',
                    start: 960,
                    end: 1200,
                    brandId: null,
                    restaurantId: 791,
                    created_at: '2021-10-01T08:39:02.000Z',
                    updated_at: '2022-05-05T12:15:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20074,
                    day: 'SUN',
                    start: 720,
                    end: 1020,
                    brandId: null,
                    restaurantId: 791,
                    created_at: '2021-10-01T08:39:02.000Z',
                    updated_at: '2022-05-05T12:15:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20075,
                    day: 'SUN',
                    start: 1020,
                    end: 1260,
                    brandId: null,
                    restaurantId: 791,
                    created_at: '2021-10-01T08:39:02.000Z',
                    updated_at: '2022-05-05T12:15:10.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
            ],
            moduleOrderingSchedules: [
                {
                    moduleOrderingScheduleId: 659,
                    created_at: '2022-05-05T12:15:35.000Z',
                    updated_at: '2022-05-05T12:15:35.000Z',
                    is_enabled: true,
                    moduleId: 8,
                    brandId: null,
                    restaurantId: 791,
                    channelId: 2,
                    isPreorderingEnabled: true,
                    weborderingSchedules: [
                        {
                            weborderingScheduleId: 6096,
                            day: 'MON',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 659,
                            created_at: '2022-05-05T12:15:35.000Z',
                            updated_at: '2022-05-05T12:15:35.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6097,
                            day: 'MON',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 659,
                            created_at: '2022-05-05T12:15:35.000Z',
                            updated_at: '2022-05-05T12:15:35.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6098,
                            day: 'TUE',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 659,
                            created_at: '2022-05-05T12:15:35.000Z',
                            updated_at: '2022-05-05T12:15:35.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6099,
                            day: 'WED',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 659,
                            created_at: '2022-05-05T12:15:35.000Z',
                            updated_at: '2022-05-05T12:15:35.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6100,
                            day: 'THU',
                            start: 540,
                            end: 600,
                            moduleOrderingScheduleId: 659,
                            created_at: '2022-05-05T12:15:35.000Z',
                            updated_at: '2022-05-05T12:15:35.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6101,
                            day: 'THU',
                            start: 600,
                            end: 840,
                            moduleOrderingScheduleId: 659,
                            created_at: '2022-05-05T12:15:35.000Z',
                            updated_at: '2022-05-05T12:15:35.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6102,
                            day: 'FRI',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 659,
                            created_at: '2022-05-05T12:15:35.000Z',
                            updated_at: '2022-05-05T12:15:35.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6103,
                            day: 'MON',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 659,
                            created_at: '2022-05-05T12:15:35.000Z',
                            updated_at: '2022-05-05T12:15:35.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6104,
                            day: 'TUE',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 659,
                            created_at: '2022-05-05T12:15:35.000Z',
                            updated_at: '2022-05-05T12:15:35.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6105,
                            day: 'TUE',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 659,
                            created_at: '2022-05-05T12:15:35.000Z',
                            updated_at: '2022-05-05T12:15:35.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6106,
                            day: 'WED',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 659,
                            created_at: '2022-05-05T12:15:35.000Z',
                            updated_at: '2022-05-05T12:15:35.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6107,
                            day: 'WED',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 659,
                            created_at: '2022-05-05T12:15:35.000Z',
                            updated_at: '2022-05-05T12:15:35.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6108,
                            day: 'THU',
                            start: 840,
                            end: 1080,
                            moduleOrderingScheduleId: 659,
                            created_at: '2022-05-05T12:15:35.000Z',
                            updated_at: '2022-05-05T12:15:35.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6109,
                            day: 'FRI',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 659,
                            created_at: '2022-05-05T12:15:35.000Z',
                            updated_at: '2022-05-05T12:15:35.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6110,
                            day: 'SAT',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 659,
                            created_at: '2022-05-05T12:15:35.000Z',
                            updated_at: '2022-05-05T12:15:35.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6111,
                            day: 'THU',
                            start: 1080,
                            end: 1320,
                            moduleOrderingScheduleId: 659,
                            created_at: '2022-05-05T12:15:35.000Z',
                            updated_at: '2022-05-05T12:15:35.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6112,
                            day: 'FRI',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 659,
                            created_at: '2022-05-05T12:15:35.000Z',
                            updated_at: '2022-05-05T12:15:35.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6113,
                            day: 'SAT',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 659,
                            created_at: '2022-05-05T12:15:35.000Z',
                            updated_at: '2022-05-05T12:15:35.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6114,
                            day: 'FRI',
                            start: 1260,
                            end: 1425,
                            moduleOrderingScheduleId: 659,
                            created_at: '2022-05-05T12:15:35.000Z',
                            updated_at: '2022-05-05T12:15:35.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6115,
                            day: 'SAT',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 659,
                            created_at: '2022-05-05T12:15:35.000Z',
                            updated_at: '2022-05-05T12:15:35.000Z',
                            is_enabled: true,
                        },
                    ],
                },
            ],
            menus: [
                {
                    menuId: 4230,
                    is_enabled: true,
                    name: 'Test',
                    hasInitModalBeenShowed: false,
                    restaurantId: 791,
                    brandId: null,
                    created_at: '2022-05-05T12:13:09.000Z',
                    updated_at: '2022-05-05T12:13:09.000Z',
                    channels: [
                        {
                            channelId: 2,
                            name: 'web',
                            canBeBlocked: true,
                            is_enabled: true,
                            isReportSource: true,
                            created_at: '2017-01-30T01:11:12.000Z',
                            updated_at: '2017-01-30T01:11:12.000Z',
                            menu_channel: {
                                channelId: 2,
                                menuId: 4230,
                                created_at: '2022-05-05T12:13:11.000Z',
                                updated_at: '2022-05-05T12:13:11.000Z',
                            },
                        },
                    ],
                },
            ],
            channels: [
                {
                    channelId: 2,
                    name: 'web',
                    canBeBlocked: true,
                    is_enabled: true,
                    isReportSource: true,
                    created_at: '2017-01-30T01:11:12.000Z',
                    updated_at: '2017-01-30T01:11:12.000Z',
                    restaurant_channel: {
                        restaurantId: 791,
                        channelId: 2,
                        created_at: '2022-05-05T12:15:21.000Z',
                        updated_at: '2022-05-05T12:15:21.000Z',
                    },
                },
            ],
            moduleStripe: null,
            consumptionModes: [
                {
                    consumptionModeId: 368,
                    type: 'MODE_TAKE_AWAY',
                    flags: 0,
                    fee: 0,
                    labelFee: null,
                    reduction: 0,
                    labelReduction: null,
                    delay: 0,
                    moduleStripeId: null,
                    stuartId: null,
                    moduleIngenicoId: null,
                    restaurantId: 791,
                    brandId: 10,
                    channelId: 2,
                    isTimeSlotModeEnabled: false,
                    additionalInformationType: null,
                    additionalInformationTitle: null,
                    additionalInformationAllowSkip: false,
                    additionalInformationValueIfSkipped: null,
                    customerShowUpNotification: false,
                    sendReminderEmailShowUpNotification: false,
                    delayBeforeSendingReminderEmailShowUpNotification: 30,
                    created_at: '2022-05-06T05:17:19.000Z',
                    updated_at: '2022-05-06T05:17:19.000Z',
                    deleted_at: null,
                },
            ],
            moduleLoyaltyRoyalties: [],
            address: {
                addressId: 1990,
                lat: 48.8648193,
                lng: 2.378607,
                timeZoneId: 'Europe/Paris',
                locality: 'Paris',
                route: 'Avenue de la République',
                postalCode: '75011',
                streetNumber: '61',
                administrativeAreaLevel1: 'Île-de-France',
                administrativeAreaLevel2: 'Département de Paris',
                country: 'France',
                googlePlaceId: '',
                providerId: 'ChIJUz6dpvpt5kcR6bjsTSZQv5c',
                phone: null,
                additionalInfo: null,
                digiCode: null,
                apartmentNumber: null,
                iconIdentifier: null,
                customerId: null,
                name: '61 Av. de la République, 75011 Paris, France',
                created_at: '2022-05-05T12:12:54.000Z',
                updated_at: '2022-05-05T12:12:55.000Z',
                deleted_at: null,
            },
        },
        {
            restaurantId: 11,
            name: 'Resto Produit Innovorder',
            delayTakeAway: 20,
            phoneIndicator: null,
            contactPhone: '0442090904',
            contactName: 'bob',
            contactEmail: 'no-reply@innovorder.fr',
            brandId: 10,
            addressId: 480,
            locale: 'fr',
            kitchenDisplayId: 2,
            currency: 'EUR',
            created_at: '2017-01-31T16:28:02.000Z',
            updated_at: '2022-03-25T15:39:34.000Z',
            is_enabled: true,
            legalId: 17,
            ewalletMinimumForScanTray: 0,
            moduleStripeId: 55,
            modulePaygreenId: 10,
            moduleSplioId: 30,
            moduleApetizPlusId: 1,
            externalId: 'restaurantEatNDrinkkCDPF2',
            moduleNeptingId: 3,
            lastShiftClosureHour: null,
            module_ordering_flows: [
                {
                    termsAndConditions: null,
                    termsOfUse: null,
                    legalNotice: null,
                    registrationConditions: 'fedzsfdfdsfdsqsfqd<p></p>',
                    customMessage:
                        "Si vous souffrez d'allergies alimentaires ou si vous suivez un régime alimentaire spécifique veuillez en aviser directement le restaurant avant de passer votre commande",
                    emailCustomMessage:
                        'Test message custom email 2 !\n<b> toto </b>\n\n<a href="google.com"> google </a>',
                    moduleOrderingFlowId: 21,
                    created_at: '2017-01-31T16:28:02.000Z',
                    updated_at: '2022-08-08T10:10:09.000Z',
                    ewalletPaymentActivated: true,
                    stripePaymentActivated: true,
                    adminCode: '0000',
                    isAlcoolBannerActivated: false,
                    isEwalletReloadButtonHidden: false,
                    isWeborderingButtonHidden: false,
                    isDeliveryEnabled: true,
                    isProductDisplayedWhenUnavailable: false,
                    isRegistrationEnabled: true,
                    isLoginEnabled: false,
                    isNFCLoginEnabled: false,
                    loginStrategy: 1,
                    authenticationEwalletCondition: false,
                    nfcCardStrategy: 'MIFARE_UID',
                    allowAuthAndUnauthOnKiosk: false,
                    JWTSecretKey: 'your-256-bit-secret',
                    timechefWebhookOrderPushEnabled: false,
                    forceOnlinePaymentForTakeAway: false,
                    isCNTRELuncheonVoucherDeclared: false,
                    isTakeAwayEnabled: true,
                    isSitInEnabled: true,
                    serviceCharge: 95,
                    takeAwayReduction: 0,
                    rushDelay: 0,
                    openAt: '2019-01-30T14:27:28.000Z',
                    kioskCssUrl: null,
                    is_enabled: true,
                    moduleId: 2,
                    brandId: null,
                    restaurantId: 11,
                    channelId: 2,
                    kioskCount: 0,
                    confirmationMessage: null,
                    confirmationTime: 6000,
                    surveyUrl: 'https://www.facebook.com/',
                    blindCarbonCopy: '',
                    isCustomCopyEmailEnabled: true,
                    customCopyEmailSubject: 'Test demails',
                    customCopyEmailTemplate: 'comande<p></p>',
                    enableCustomerEmail: true,
                    useRegistrationConditions: false,
                    onlinePaymentDiscount: null,
                    invoiceDownloadEnabled: true,
                    afterOrderReturnButtonText: 'Revenir au menu ?',
                    afterOrderReturnButtonLink: 'init.home.restaurant.menu.category',
                    orderFinalValidation: false,
                    useGTMCookiePolicyAsDefault: false,
                },
            ],
            pickupSchedule: [
                {
                    pickupScheduleId: 20417,
                    day: 'MON',
                    start: 540,
                    end: 1425,
                    brandId: null,
                    restaurantId: 11,
                    created_at: '2022-07-29T13:55:24.000Z',
                    updated_at: '2022-07-29T13:55:24.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20418,
                    day: 'TUE',
                    start: 540,
                    end: 1380,
                    brandId: null,
                    restaurantId: 11,
                    created_at: '2022-07-29T13:55:24.000Z',
                    updated_at: '2022-07-29T13:55:24.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20419,
                    day: 'WED',
                    start: 540,
                    end: 1380,
                    brandId: null,
                    restaurantId: 11,
                    created_at: '2022-07-29T13:55:24.000Z',
                    updated_at: '2022-07-29T13:55:24.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20420,
                    day: 'THU',
                    start: 0,
                    end: 1440,
                    brandId: null,
                    restaurantId: 11,
                    created_at: '2022-07-29T13:55:24.000Z',
                    updated_at: '2022-07-29T13:55:24.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20421,
                    day: 'FRI',
                    start: 0,
                    end: 1440,
                    brandId: null,
                    restaurantId: 11,
                    created_at: '2022-07-29T13:55:24.000Z',
                    updated_at: '2022-07-29T13:55:24.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 3805,
                            pickupScheduleId: 20421,
                            consumptionMode: '2',
                            orderingQuota: 0,
                            created_at: '2022-07-29T13:55:24.000Z',
                            updated_at: '2022-07-29T13:55:24.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 20422,
                    day: 'SAT',
                    start: 540,
                    end: 1380,
                    brandId: null,
                    restaurantId: 11,
                    created_at: '2022-07-29T13:55:24.000Z',
                    updated_at: '2022-07-29T13:55:24.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 20423,
                    day: 'SUN',
                    start: 540,
                    end: 1380,
                    brandId: null,
                    restaurantId: 11,
                    created_at: '2022-07-29T13:55:24.000Z',
                    updated_at: '2022-07-29T13:55:24.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
            ],
            moduleOrderingSchedules: [
                {
                    moduleOrderingScheduleId: 14,
                    created_at: '2017-01-31T16:28:03.000Z',
                    updated_at: '2022-05-20T06:18:09.000Z',
                    is_enabled: true,
                    moduleId: 8,
                    brandId: null,
                    restaurantId: 11,
                    channelId: 2,
                    isPreorderingEnabled: true,
                    weborderingSchedules: [
                        {
                            weborderingScheduleId: 6173,
                            day: 'MON',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 14,
                            created_at: '2022-05-20T06:18:10.000Z',
                            updated_at: '2022-05-20T06:18:10.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6174,
                            day: 'MON',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 14,
                            created_at: '2022-05-20T06:18:10.000Z',
                            updated_at: '2022-05-20T06:18:10.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6175,
                            day: 'TUE',
                            start: 420,
                            end: 900,
                            moduleOrderingScheduleId: 14,
                            created_at: '2022-05-20T06:18:10.000Z',
                            updated_at: '2022-05-20T06:18:10.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6176,
                            day: 'WED',
                            start: 420,
                            end: 780,
                            moduleOrderingScheduleId: 14,
                            created_at: '2022-05-20T06:18:10.000Z',
                            updated_at: '2022-05-20T06:18:10.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6177,
                            day: 'FRI',
                            start: 0,
                            end: 780,
                            moduleOrderingScheduleId: 14,
                            created_at: '2022-05-20T06:18:10.000Z',
                            updated_at: '2022-05-20T06:18:10.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6178,
                            day: 'SAT',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 14,
                            created_at: '2022-05-20T06:18:10.000Z',
                            updated_at: '2022-05-20T06:18:10.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6179,
                            day: 'MON',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 14,
                            created_at: '2022-05-20T06:18:10.000Z',
                            updated_at: '2022-05-20T06:18:10.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6180,
                            day: 'TUE',
                            start: 900,
                            end: 1140,
                            moduleOrderingScheduleId: 14,
                            created_at: '2022-05-20T06:18:10.000Z',
                            updated_at: '2022-05-20T06:18:10.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6181,
                            day: 'TUE',
                            start: 1140,
                            end: 1380,
                            moduleOrderingScheduleId: 14,
                            created_at: '2022-05-20T06:18:10.000Z',
                            updated_at: '2022-05-20T06:18:10.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6182,
                            day: 'WED',
                            start: 840,
                            end: 1260,
                            moduleOrderingScheduleId: 14,
                            created_at: '2022-05-20T06:18:10.000Z',
                            updated_at: '2022-05-20T06:18:10.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6183,
                            day: 'THU',
                            start: 420,
                            end: 1260,
                            moduleOrderingScheduleId: 14,
                            created_at: '2022-05-20T06:18:10.000Z',
                            updated_at: '2022-05-20T06:18:10.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6184,
                            day: 'FRI',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 14,
                            created_at: '2022-05-20T06:18:10.000Z',
                            updated_at: '2022-05-20T06:18:10.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6185,
                            day: 'THU',
                            start: 1260,
                            end: 1425,
                            moduleOrderingScheduleId: 14,
                            created_at: '2022-05-20T06:18:10.000Z',
                            updated_at: '2022-05-20T06:18:10.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6186,
                            day: 'FRI',
                            start: 1020,
                            end: 1260,
                            moduleOrderingScheduleId: 14,
                            created_at: '2022-05-20T06:18:10.000Z',
                            updated_at: '2022-05-20T06:18:10.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 6187,
                            day: 'SAT',
                            start: 780,
                            end: 1020,
                            moduleOrderingScheduleId: 14,
                            created_at: '2022-05-20T06:18:10.000Z',
                            updated_at: '2022-05-20T06:18:10.000Z',
                            is_enabled: true,
                        },
                    ],
                },
            ],
            menus: [
                {
                    menuId: 4264,
                    is_enabled: true,
                    name: 'bowl',
                    hasInitModalBeenShowed: false,
                    restaurantId: 11,
                    brandId: null,
                    created_at: '2022-05-20T06:08:36.000Z',
                    updated_at: '2022-05-20T06:08:36.000Z',
                    channels: [
                        {
                            channelId: 2,
                            name: 'web',
                            canBeBlocked: true,
                            is_enabled: true,
                            isReportSource: true,
                            created_at: '2017-01-30T01:11:12.000Z',
                            updated_at: '2017-01-30T01:11:12.000Z',
                            menu_channel: {
                                channelId: 2,
                                menuId: 4264,
                                created_at: '2022-05-20T06:09:52.000Z',
                                updated_at: '2022-05-20T06:09:52.000Z',
                            },
                        },
                    ],
                },
            ],
            channels: [
                {
                    channelId: 2,
                    name: 'web',
                    canBeBlocked: true,
                    is_enabled: true,
                    isReportSource: true,
                    created_at: '2017-01-30T01:11:12.000Z',
                    updated_at: '2017-01-30T01:11:12.000Z',
                    restaurant_channel: {
                        restaurantId: 11,
                        channelId: 2,
                        created_at: '2021-02-24T14:09:52.000Z',
                        updated_at: '2021-02-24T14:09:52.000Z',
                    },
                },
            ],
            moduleStripe: {
                moduleStripeId: 55,
                label: "Eat'n Drinkk Stripe",
                isCNTRELuncheonVoucherDeclared: false,
                stripeUserId: 'acct_1GzcvlK613VEK2fF',
                stripePublishableKey:
                    'pk_test_51GzcvlK613VEK2fF2FM9nSFyBpa3jupHXLs3uXeq4zdAkKLyEQnQAgnVmwsArRZeiryzYjKU21Nto67EKACVaeSd002cZXKdny',
                liveMode: false,
                isActivated: true,
                stateConnect: null,
                brandId: 10,
                created_at: '2020-06-30T06:26:53.000Z',
                updated_at: '2020-06-30T06:27:02.000Z',
                deleted_at: null,
            },
            consumptionModes: [
                {
                    consumptionModeId: 10,
                    type: 'MODE_TAKE_AWAY',
                    flags: 6,
                    fee: 0,
                    labelFee: null,
                    reduction: 0,
                    labelReduction: null,
                    delay: 0,
                    moduleStripeId: null,
                    stuartId: null,
                    moduleIngenicoId: null,
                    restaurantId: 11,
                    brandId: 10,
                    channelId: 2,
                    isTimeSlotModeEnabled: false,
                    additionalInformationType: null,
                    additionalInformationTitle: 'Votre numéro de table :',
                    additionalInformationAllowSkip: true,
                    additionalInformationValueIfSkipped: 'Je ne connais pas ma table',
                    customerShowUpNotification: false,
                    sendReminderEmailShowUpNotification: false,
                    delayBeforeSendingReminderEmailShowUpNotification: 10,
                    created_at: '2017-09-01T10:08:23.000Z',
                    updated_at: '2022-05-20T06:24:38.000Z',
                    deleted_at: null,
                },
                {
                    consumptionModeId: 67,
                    type: 'MODE_DELIVERY',
                    flags: 6,
                    fee: 95,
                    labelFee: null,
                    reduction: null,
                    labelReduction: null,
                    delay: 20,
                    moduleStripeId: null,
                    stuartId: 20,
                    moduleIngenicoId: null,
                    restaurantId: 11,
                    brandId: 10,
                    channelId: 2,
                    isTimeSlotModeEnabled: false,
                    additionalInformationType: null,
                    additionalInformationTitle: 'Veuillez saisir votre numéro de chambre :',
                    additionalInformationAllowSkip: true,
                    additionalInformationValueIfSkipped: 'Sans chambre attribuée',
                    customerShowUpNotification: false,
                    sendReminderEmailShowUpNotification: false,
                    delayBeforeSendingReminderEmailShowUpNotification: 30,
                    created_at: '2017-09-01T10:08:23.000Z',
                    updated_at: '2022-04-14T08:43:31.000Z',
                    deleted_at: null,
                },
                {
                    consumptionModeId: 78,
                    type: 'MODE_SIT_IN',
                    flags: 6,
                    fee: 0,
                    labelFee: null,
                    reduction: 0,
                    labelReduction: null,
                    delay: 0,
                    moduleStripeId: null,
                    stuartId: null,
                    moduleIngenicoId: null,
                    restaurantId: 11,
                    brandId: 10,
                    channelId: 2,
                    isTimeSlotModeEnabled: false,
                    additionalInformationType: 'TABLE_NUMBER',
                    additionalInformationTitle: 'Saisissez votre numéro de table :',
                    additionalInformationAllowSkip: true,
                    additionalInformationValueIfSkipped: "Je n'ai pas cette information",
                    customerShowUpNotification: false,
                    sendReminderEmailShowUpNotification: false,
                    delayBeforeSendingReminderEmailShowUpNotification: 30,
                    created_at: '2017-10-04T14:08:00.000Z',
                    updated_at: '2021-12-09T15:17:02.000Z',
                    deleted_at: null,
                },
                {
                    consumptionModeId: 79,
                    type: 'MODE_DRIVE',
                    flags: 3,
                    fee: 563,
                    labelFee: null,
                    reduction: 0,
                    labelReduction: null,
                    delay: 0,
                    moduleStripeId: null,
                    stuartId: null,
                    moduleIngenicoId: null,
                    restaurantId: 11,
                    brandId: 10,
                    channelId: 2,
                    isTimeSlotModeEnabled: false,
                    additionalInformationType: null,
                    additionalInformationTitle: 'Souhaitez-vous votre burger avec ou sans élan ?',
                    additionalInformationAllowSkip: true,
                    additionalInformationValueIfSkipped: 'Je ne commande que des boissons',
                    customerShowUpNotification: false,
                    sendReminderEmailShowUpNotification: false,
                    delayBeforeSendingReminderEmailShowUpNotification: 30,
                    created_at: '2017-10-04T14:08:05.000Z',
                    updated_at: '2021-12-09T15:17:02.000Z',
                    deleted_at: null,
                },
            ],
            moduleLoyaltyRoyalties: [
                {
                    moduleLoyaltyRoyaltyId: 2,
                    is_enabled: true,
                    percentage: 8000,
                    moduleId: 17,
                    brandId: null,
                    restaurantId: 11,
                    channelId: 6,
                    customCss:
                        '#intro * {\n    margin: 0;\n    padding: 0;\n}\n\n#intro .description {\n    margin-top: 20px;\n    margin-bottom: 50px;\n    width: 80%;\n    text-align: center;\n}\n\n#intro .content-container {\n    width: 100%;\n    padding-bottom: 30px;\n}\n\n#intro .content-container h4 {\n    text-align: center;\n    margin-bottom: 10px;\n}\n\n\n#intro .content-container .perks {\n    background-color: #fdfdfd;\n    border: solid 1px #e2e2e2;\n    padding: 20px 0;\n    width: 100%;\n    margin: 10px 0;\n}\n\n#intro .content-container .perks h5 {\n    font-family: avenir-heavy;\n    text-transform: uppercase;\n}\n\n#intro .content-container .perks i {\n    /*color: $brand-color;*/\n    font-size: 24px;\n}\n\n#intro .content-container .perks p {\n    font-size: 12px;\n}\n    \n#intro .content-container fio-button {\n    /*background-color: $brand-color;*/\n    font-size: 20px;\n    font-family: avenir-heavy;\n    padding: 15px 70px;\n    border-radius: 4px;\n    /*color: $text-on-brand;*/\n    margin-bottom: 20px;\n}',
                    customHtmlMessage:
                        '<div layout="column" layout-align="center center">\n    <p class="description">Grâce à votre carte de fidélité Fresh Burritos, vous cumulez des euros à chacune de vos visites dans nos restaurants ou de vos commandes passées sur notre site internet.</p>\n    <section class="content-container">\n        <h4>Découvrez les avantages de la carte de fidélité</h4>\n        <div class="perks" layout="row" layout-align="space-around center">\n            <i class="icon icon-feed-price"></i>\n            <div flex="80">\n                <h5>5% DE VOTRE NOTE CRÉDITÉ EN AVOIR</h5>\n                <p>sur votre carte à chaque passage en caisse</p>\n            </div>\n        </div>\n        <div class="perks" layout="row" layout-align="space-around center">\n            <i class="icon icon-feed-wallet"></i>\n            <div flex="80">\n                <h5>VOTRE COMPTE FIDÉLITÉ</h5>\n                <p>consultable à tout moment sur internet.</p>\n            </div>\n        </div>\n        <div class="perks" layout="row" layout-align="space-around center">\n            <i class="icon icon-coin-euro"></i>\n            <div flex="80">\n                <h5>VOTRE SOLDE D\'EUROS SAUVEGARDÉ</h5>\n                <p>même en cas de perte de votre carte ! </p>\n            </div>\n        </div>\n    </section>\n</div>\n',
                    created_at: '2017-06-23T17:01:13.000Z',
                    updated_at: '2021-09-27T09:59:57.000Z',
                    deleted_at: null,
                },
            ],
            address: {
                addressId: 480,
                lat: 48.8689168,
                lng: 2.3527634,
                timeZoneId: 'Europe/Paris',
                locality: 'Paris',
                route: 'Rue Blondel',
                postalCode: '75002',
                streetNumber: '30',
                administrativeAreaLevel1: 'Île-de-France',
                administrativeAreaLevel2: 'Département de Paris',
                country: 'France',
                googlePlaceId: 'ChIJ3e6Ykgdu5kcRJXtvh-3JyLU',
                providerId: 'ChIJkzIxGRFu5kcRliBS_bQYIts',
                phone: null,
                additionalInfo: null,
                digiCode: null,
                apartmentNumber: null,
                iconIdentifier: null,
                customerId: null,
                name: '30 Rue Blondel, 75002 Paris, France',
                created_at: '2017-01-31T16:28:02.000Z',
                updated_at: '2020-11-14T06:14:20.000Z',
                deleted_at: null,
            },
        },
        {
            restaurantId: 65,
            name: "eat'n'drink - EliorCEL",
            delayTakeAway: null,
            phoneIndicator: null,
            contactPhone: '0123456789',
            contactName: 'bob',
            contactEmail: 'bob@bob.bob',
            brandId: 10,
            addressId: 1040,
            locale: 'fr',
            kitchenDisplayId: 13,
            currency: 'EUR',
            created_at: '2018-04-09T13:53:41.000Z',
            updated_at: '2020-10-20T07:55:42.000Z',
            is_enabled: true,
            legalId: 26,
            ewalletMinimumForScanTray: null,
            moduleStripeId: 17,
            modulePaygreenId: 1,
            moduleSplioId: null,
            moduleApetizPlusId: null,
            externalId: 'aa',
            moduleNeptingId: null,
            lastShiftClosureHour: null,
            module_ordering_flows: [
                {
                    termsAndConditions: null,
                    termsOfUse: null,
                    legalNotice: null,
                    registrationConditions:
                        "<div><div>Vous allez communiquer vos données à caractère personnel dans le cadre de la création de votre compte qui vous permet de commander en ligne et de bénéficier d’offres et d’avantages sur les produits proposés par les restaurants de l’enseigne Poivre Rouge. Les champs marqués d’un astérisque doivent être renseignés obligatoirement pour valider votre inscription. A défaut, votre demande d’inscription ne sera pas prise en compte. Vos données à caractère personnel sont collectées à des fins de traitement de vos commandes en lignes, la réalisation d’actions de fidélisation ainsi qu’à des fins de prospection commerciale. Les traitements de données à caractère personnel mentionnés sont juridiquement basés sur votre consentement et l’exécution du contrat conclu avec ITM RESTAURATION. Le responsable de traitement est ITM RESTAURATION, située 3 allée des Mousquetaires. ITM RESTAURATION peut recourir à des sous-traitants. Les destinataires de vos données personnelles sont les restaurants portant l’enseigne Poivre Rouge.</div><div>Les données collectées sont conservées, par défaut, pour une durée de trois ans à compter de leur collecte ou, le cas échéant, de votre dernière connexion à votre compte puis supprimées. ITM RESTAURATION conserve ces données pour une durée plus importante lorsque les obligations légales et réglementaires l’imposent.</div><div>Conformément au Règlement général pour la protection des données n°2016/679 et à la loi dite « Informatique et libertés » du 6 janvier 1978 dans sa dernière version, vous disposez d’un droit d’accès, de rectification, d’effacement des données à caractère personnel qui vous concernent, d’un droit à la limitation du traitement, d’un droit d’opposition, d’un droit à la portabilité de vos données et du droit de définir des directives relatives à la conservation, à l'effacement et à la communication de vos données à caractère personnel après votre décès.</div><div>Vous pouvez exercer vos droits en vous adressant directement par courrier postal au Service Marketing Poivre Rouge 3 Allée des Mousquetaires 91078 Bondoufle Cedex.</div><div>Pour toute autre demande, vous pouvez également contacter le délégué à la protection des données par courriel à l’adresse dpolesmousquetaires@mousquetaires.com</div><div>En cas de réclamation, vous disposez du droit de saisir la CNIL.</div></div><p></p>",
                    customMessage:
                        "Si vous souffrez d'allergies alimentaires ou si vous suivez un régime alimentaire spécifique veuillez en aviser directement le restaurant avant de passer votre commande.",
                    emailCustomMessage: null,
                    moduleOrderingFlowId: 140,
                    created_at: '2018-04-09T13:54:23.000Z',
                    updated_at: '2022-08-01T16:07:00.000Z',
                    ewalletPaymentActivated: true,
                    stripePaymentActivated: false,
                    adminCode: '0000',
                    isAlcoolBannerActivated: false,
                    isEwalletReloadButtonHidden: false,
                    isWeborderingButtonHidden: false,
                    isDeliveryEnabled: true,
                    isProductDisplayedWhenUnavailable: false,
                    isRegistrationEnabled: false,
                    isLoginEnabled: false,
                    isNFCLoginEnabled: false,
                    loginStrategy: 1,
                    authenticationEwalletCondition: false,
                    nfcCardStrategy: 'MIFARE_UID',
                    allowAuthAndUnauthOnKiosk: false,
                    JWTSecretKey: 'your-256-bit-secret2',
                    timechefWebhookOrderPushEnabled: false,
                    forceOnlinePaymentForTakeAway: false,
                    isCNTRELuncheonVoucherDeclared: false,
                    isTakeAwayEnabled: true,
                    isSitInEnabled: true,
                    serviceCharge: 0,
                    takeAwayReduction: 1000,
                    rushDelay: 0,
                    openAt: '2017-01-31T16:27:14.000Z',
                    kioskCssUrl: null,
                    is_enabled: true,
                    moduleId: 2,
                    brandId: null,
                    restaurantId: 65,
                    channelId: 2,
                    kioskCount: 0,
                    confirmationMessage: null,
                    confirmationTime: 6000,
                    surveyUrl: '',
                    blindCarbonCopy: '',
                    isCustomCopyEmailEnabled: false,
                    customCopyEmailSubject: '',
                    customCopyEmailTemplate: '',
                    enableCustomerEmail: true,
                    useRegistrationConditions: false,
                    onlinePaymentDiscount: null,
                    invoiceDownloadEnabled: true,
                    afterOrderReturnButtonText: null,
                    afterOrderReturnButtonLink: null,
                    orderFinalValidation: false,
                    useGTMCookiePolicyAsDefault: false,
                },
            ],
            pickupSchedule: [
                {
                    pickupScheduleId: 15130,
                    day: 'FRI',
                    start: 0,
                    end: 480,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:54.000Z',
                    updated_at: '2021-03-24T10:56:54.000Z',
                    is_enabled: true,
                    orderingQuotas: [],
                },
                {
                    pickupScheduleId: 15131,
                    day: 'MON',
                    start: 540,
                    end: 780,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:54.000Z',
                    updated_at: '2021-03-24T10:56:54.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2528,
                            pickupScheduleId: 15131,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:54.000Z',
                            updated_at: '2021-03-24T10:56:54.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15132,
                    day: 'MON',
                    start: 780,
                    end: 1020,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:54.000Z',
                    updated_at: '2021-03-24T10:56:54.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2529,
                            pickupScheduleId: 15132,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:55.000Z',
                            updated_at: '2021-03-24T10:56:55.000Z',
                        },
                        {
                            orderingQuotaId: 2530,
                            pickupScheduleId: 15132,
                            consumptionMode: '1',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:55.000Z',
                            updated_at: '2021-03-24T10:56:55.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15133,
                    day: 'TUE',
                    start: 540,
                    end: 780,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:55.000Z',
                    updated_at: '2021-03-24T10:56:55.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2531,
                            pickupScheduleId: 15133,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:55.000Z',
                            updated_at: '2021-03-24T10:56:55.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15134,
                    day: 'WED',
                    start: 540,
                    end: 780,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:55.000Z',
                    updated_at: '2021-03-24T10:56:55.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2532,
                            pickupScheduleId: 15134,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:55.000Z',
                            updated_at: '2021-03-24T10:56:55.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15135,
                    day: 'MON',
                    start: 1020,
                    end: 1260,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:55.000Z',
                    updated_at: '2021-03-24T10:56:55.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2533,
                            pickupScheduleId: 15135,
                            consumptionMode: '1',
                            orderingQuota: 2,
                            created_at: '2021-03-24T10:56:55.000Z',
                            updated_at: '2021-03-24T10:56:55.000Z',
                        },
                        {
                            orderingQuotaId: 2534,
                            pickupScheduleId: 15135,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:55.000Z',
                            updated_at: '2021-03-24T10:56:55.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15136,
                    day: 'TUE',
                    start: 780,
                    end: 1020,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:55.000Z',
                    updated_at: '2021-03-24T10:56:55.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2535,
                            pickupScheduleId: 15136,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:55.000Z',
                            updated_at: '2021-03-24T10:56:55.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15137,
                    day: 'TUE',
                    start: 1020,
                    end: 1260,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:55.000Z',
                    updated_at: '2021-03-24T10:56:55.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2536,
                            pickupScheduleId: 15137,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:55.000Z',
                            updated_at: '2021-03-24T10:56:55.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15138,
                    day: 'WED',
                    start: 780,
                    end: 1020,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:55.000Z',
                    updated_at: '2021-03-24T10:56:55.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2537,
                            pickupScheduleId: 15138,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:55.000Z',
                            updated_at: '2021-03-24T10:56:55.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15139,
                    day: 'THU',
                    start: 540,
                    end: 780,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:55.000Z',
                    updated_at: '2021-03-24T10:56:55.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2538,
                            pickupScheduleId: 15139,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:55.000Z',
                            updated_at: '2021-03-24T10:56:55.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15140,
                    day: 'FRI',
                    start: 540,
                    end: 780,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:55.000Z',
                    updated_at: '2021-03-24T10:56:55.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2539,
                            pickupScheduleId: 15140,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:55.000Z',
                            updated_at: '2021-03-24T10:56:55.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15141,
                    day: 'SAT',
                    start: 540,
                    end: 780,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:55.000Z',
                    updated_at: '2021-03-24T10:56:55.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2540,
                            pickupScheduleId: 15141,
                            consumptionMode: '4',
                            orderingQuota: 10,
                            created_at: '2021-03-24T10:56:55.000Z',
                            updated_at: '2021-03-24T10:56:55.000Z',
                        },
                        {
                            orderingQuotaId: 2541,
                            pickupScheduleId: 15141,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:55.000Z',
                            updated_at: '2021-03-24T10:56:55.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15142,
                    day: 'SUN',
                    start: 540,
                    end: 780,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:55.000Z',
                    updated_at: '2021-03-24T10:56:55.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2542,
                            pickupScheduleId: 15142,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:55.000Z',
                            updated_at: '2021-03-24T10:56:55.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15143,
                    day: 'WED',
                    start: 1020,
                    end: 1080,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:55.000Z',
                    updated_at: '2021-03-24T10:56:55.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2543,
                            pickupScheduleId: 15143,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:55.000Z',
                            updated_at: '2021-03-24T10:56:55.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15144,
                    day: 'FRI',
                    start: 780,
                    end: 1020,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:55.000Z',
                    updated_at: '2021-03-24T10:56:55.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2544,
                            pickupScheduleId: 15144,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:55.000Z',
                            updated_at: '2021-03-24T10:56:55.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15145,
                    day: 'WED',
                    start: 1080,
                    end: 1140,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:55.000Z',
                    updated_at: '2021-03-24T10:56:55.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2545,
                            pickupScheduleId: 15145,
                            consumptionMode: '1',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:55.000Z',
                            updated_at: '2021-03-24T10:56:55.000Z',
                        },
                        {
                            orderingQuotaId: 2546,
                            pickupScheduleId: 15145,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:55.000Z',
                            updated_at: '2021-03-24T10:56:55.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15146,
                    day: 'THU',
                    start: 1020,
                    end: 1320,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:55.000Z',
                    updated_at: '2021-03-24T10:56:55.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2547,
                            pickupScheduleId: 15146,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:55.000Z',
                            updated_at: '2021-03-24T10:56:55.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15147,
                    day: 'THU',
                    start: 780,
                    end: 1020,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:55.000Z',
                    updated_at: '2021-03-24T10:56:55.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2548,
                            pickupScheduleId: 15147,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:56.000Z',
                            updated_at: '2021-03-24T10:56:56.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15148,
                    day: 'FRI',
                    start: 1020,
                    end: 1260,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:56.000Z',
                    updated_at: '2021-03-24T10:56:56.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2549,
                            pickupScheduleId: 15148,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:56.000Z',
                            updated_at: '2021-03-24T10:56:56.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15149,
                    day: 'SAT',
                    start: 1155,
                    end: 1170,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:56.000Z',
                    updated_at: '2021-03-24T10:56:56.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2550,
                            pickupScheduleId: 15149,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:56.000Z',
                            updated_at: '2021-03-24T10:56:56.000Z',
                        },
                        {
                            orderingQuotaId: 2551,
                            pickupScheduleId: 15149,
                            consumptionMode: '4',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:56.000Z',
                            updated_at: '2021-03-24T10:56:56.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15150,
                    day: 'SAT',
                    start: 1140,
                    end: 1155,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:56.000Z',
                    updated_at: '2021-03-24T10:56:56.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2552,
                            pickupScheduleId: 15150,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:56.000Z',
                            updated_at: '2021-03-24T10:56:56.000Z',
                        },
                        {
                            orderingQuotaId: 2553,
                            pickupScheduleId: 15150,
                            consumptionMode: '4',
                            orderingQuota: 10,
                            created_at: '2021-03-24T10:56:56.000Z',
                            updated_at: '2021-03-24T10:56:56.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15151,
                    day: 'SAT',
                    start: 1170,
                    end: 1185,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:56.000Z',
                    updated_at: '2021-03-24T10:56:56.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2554,
                            pickupScheduleId: 15151,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:56.000Z',
                            updated_at: '2021-03-24T10:56:56.000Z',
                        },
                        {
                            orderingQuotaId: 2555,
                            pickupScheduleId: 15151,
                            consumptionMode: '3',
                            orderingQuota: 3,
                            created_at: '2021-03-24T10:56:56.000Z',
                            updated_at: '2021-03-24T10:56:56.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15152,
                    day: 'SAT',
                    start: 1200,
                    end: 1215,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:56.000Z',
                    updated_at: '2021-03-24T10:56:56.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2556,
                            pickupScheduleId: 15152,
                            consumptionMode: '2',
                            orderingQuota: 2,
                            created_at: '2021-03-24T10:56:56.000Z',
                            updated_at: '2021-03-24T10:56:56.000Z',
                        },
                        {
                            orderingQuotaId: 2557,
                            pickupScheduleId: 15152,
                            consumptionMode: '4',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:56.000Z',
                            updated_at: '2021-03-24T10:56:56.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15153,
                    day: 'SAT',
                    start: 1215,
                    end: 1230,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:56.000Z',
                    updated_at: '2021-03-24T10:56:56.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2558,
                            pickupScheduleId: 15153,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:56.000Z',
                            updated_at: '2021-03-24T10:56:56.000Z',
                        },
                        {
                            orderingQuotaId: 2559,
                            pickupScheduleId: 15153,
                            consumptionMode: '3',
                            orderingQuota: 2,
                            created_at: '2021-03-24T10:56:56.000Z',
                            updated_at: '2021-03-24T10:56:56.000Z',
                        },
                        {
                            orderingQuotaId: 2560,
                            pickupScheduleId: 15153,
                            consumptionMode: '4',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:56.000Z',
                            updated_at: '2021-03-24T10:56:56.000Z',
                        },
                    ],
                },
                {
                    pickupScheduleId: 15154,
                    day: 'SAT',
                    start: 1230,
                    end: 1245,
                    brandId: null,
                    restaurantId: 65,
                    created_at: '2021-03-24T10:56:56.000Z',
                    updated_at: '2021-03-24T10:56:56.000Z',
                    is_enabled: true,
                    orderingQuotas: [
                        {
                            orderingQuotaId: 2561,
                            pickupScheduleId: 15154,
                            consumptionMode: '2',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:56.000Z',
                            updated_at: '2021-03-24T10:56:56.000Z',
                        },
                        {
                            orderingQuotaId: 2562,
                            pickupScheduleId: 15154,
                            consumptionMode: '3',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:56.000Z',
                            updated_at: '2021-03-24T10:56:56.000Z',
                        },
                        {
                            orderingQuotaId: 2563,
                            pickupScheduleId: 15154,
                            consumptionMode: '4',
                            orderingQuota: 1,
                            created_at: '2021-03-24T10:56:56.000Z',
                            updated_at: '2021-03-24T10:56:56.000Z',
                        },
                    ],
                },
            ],
            moduleOrderingSchedules: [
                {
                    moduleOrderingScheduleId: 88,
                    created_at: '2018-04-09T13:54:23.000Z',
                    updated_at: '2019-08-08T15:29:48.000Z',
                    is_enabled: true,
                    moduleId: 8,
                    brandId: null,
                    restaurantId: 65,
                    channelId: 2,
                    isPreorderingEnabled: true,
                    weborderingSchedules: [
                        {
                            weborderingScheduleId: 1009,
                            day: 'THU',
                            start: 540,
                            end: 600,
                            moduleOrderingScheduleId: 88,
                            created_at: '2019-03-19T11:05:32.000Z',
                            updated_at: '2019-03-19T11:05:32.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 1010,
                            day: 'MON',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 88,
                            created_at: '2019-03-19T11:05:32.000Z',
                            updated_at: '2019-03-19T11:05:32.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 1011,
                            day: 'SAT',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 88,
                            created_at: '2019-03-19T11:05:32.000Z',
                            updated_at: '2019-03-19T11:05:32.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 1012,
                            day: 'FRI',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 88,
                            created_at: '2019-03-19T11:05:32.000Z',
                            updated_at: '2019-03-19T11:05:32.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 1013,
                            day: 'THU',
                            start: 600,
                            end: 1080,
                            moduleOrderingScheduleId: 88,
                            created_at: '2019-03-19T11:05:32.000Z',
                            updated_at: '2019-03-19T11:05:32.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 1014,
                            day: 'WED',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 88,
                            created_at: '2019-03-19T11:05:32.000Z',
                            updated_at: '2019-03-19T11:05:32.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 1015,
                            day: 'TUE',
                            start: 540,
                            end: 780,
                            moduleOrderingScheduleId: 88,
                            created_at: '2019-03-19T11:05:32.000Z',
                            updated_at: '2019-03-19T11:05:32.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 1016,
                            day: 'SAT',
                            start: 780,
                            end: 1080,
                            moduleOrderingScheduleId: 88,
                            created_at: '2019-03-19T11:05:32.000Z',
                            updated_at: '2019-03-19T11:05:32.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 1017,
                            day: 'FRI',
                            start: 780,
                            end: 1080,
                            moduleOrderingScheduleId: 88,
                            created_at: '2019-03-19T11:05:32.000Z',
                            updated_at: '2019-03-19T11:05:32.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 1018,
                            day: 'MON',
                            start: 780,
                            end: 1080,
                            moduleOrderingScheduleId: 88,
                            created_at: '2019-03-19T11:05:32.000Z',
                            updated_at: '2019-03-19T11:05:32.000Z',
                            is_enabled: true,
                        },
                        {
                            weborderingScheduleId: 1019,
                            day: 'WED',
                            start: 780,
                            end: 1080,
                            moduleOrderingScheduleId: 88,
                            created_at: '2019-03-19T11:05:32.000Z',
                            updated_at: '2019-03-19T11:05:32.000Z',
                            is_enabled: true,
                        },
                    ],
                },
            ],
            menus: [
                {
                    menuId: 5725,
                    is_enabled: true,
                    name: 'prperod',
                    hasInitModalBeenShowed: false,
                    restaurantId: 65,
                    brandId: null,
                    created_at: '2022-08-01T16:01:56.000Z',
                    updated_at: '2022-08-01T16:01:56.000Z',
                    channels: [
                        {
                            channelId: 2,
                            name: 'web',
                            canBeBlocked: true,
                            is_enabled: true,
                            isReportSource: true,
                            created_at: '2017-01-30T01:11:12.000Z',
                            updated_at: '2017-01-30T01:11:12.000Z',
                            menu_channel: {
                                channelId: 2,
                                menuId: 5725,
                                created_at: '2022-08-01T16:03:19.000Z',
                                updated_at: '2022-08-01T16:03:19.000Z',
                            },
                        },
                    ],
                },
            ],
            channels: [
                {
                    channelId: 2,
                    name: 'web',
                    canBeBlocked: true,
                    is_enabled: true,
                    isReportSource: true,
                    created_at: '2017-01-30T01:11:12.000Z',
                    updated_at: '2017-01-30T01:11:12.000Z',
                    restaurant_channel: {
                        restaurantId: 65,
                        channelId: 2,
                        created_at: '2021-02-23T13:12:39.000Z',
                        updated_at: '2021-02-23T13:12:39.000Z',
                    },
                },
            ],
            moduleStripe: {
                moduleStripeId: 17,
                label: "Eat'n'drink Stripe",
                isCNTRELuncheonVoucherDeclared: false,
                stripeUserId: 'acct_1KTNUXFscUAPoZMJ',
                stripePublishableKey:
                    'pk_test_51KTNUXFscUAPoZMJ36xNbGicJoltoCMjOSBDhYqjQ3tPTVCnnBqrn03HKbbsVqgIrEeOKl2tLYIl8Nmtbo8vqmoM00054wkYxN',
                liveMode: false,
                isActivated: true,
                stateConnect: null,
                brandId: 10,
                created_at: '2017-09-01T10:08:27.000Z',
                updated_at: '2022-02-15T09:38:39.000Z',
                deleted_at: null,
            },
            consumptionModes: [
                {
                    consumptionModeId: 105,
                    type: 'MODE_DELIVERY',
                    flags: 0,
                    fee: 0,
                    labelFee: null,
                    reduction: 0,
                    labelReduction: null,
                    delay: 0,
                    moduleStripeId: null,
                    stuartId: null,
                    moduleIngenicoId: null,
                    restaurantId: 65,
                    brandId: 10,
                    channelId: 2,
                    isTimeSlotModeEnabled: true,
                    additionalInformationType: null,
                    additionalInformationTitle: 'Ajoutez une information sur votre livraison',
                    additionalInformationAllowSkip: true,
                    additionalInformationValueIfSkipped: 'Aucune info à ajouter',
                    customerShowUpNotification: false,
                    sendReminderEmailShowUpNotification: false,
                    delayBeforeSendingReminderEmailShowUpNotification: 30,
                    created_at: '2018-04-10T14:40:24.000Z',
                    updated_at: '2021-02-22T22:38:04.000Z',
                    deleted_at: null,
                },
                {
                    consumptionModeId: 106,
                    type: 'MODE_TAKE_AWAY',
                    flags: 2,
                    fee: 0,
                    labelFee: null,
                    reduction: 0,
                    labelReduction: null,
                    delay: 0,
                    moduleStripeId: null,
                    stuartId: null,
                    moduleIngenicoId: null,
                    restaurantId: 65,
                    brandId: 10,
                    channelId: 2,
                    isTimeSlotModeEnabled: false,
                    additionalInformationType: null,
                    additionalInformationTitle: "Bonjour c'est un commentaire",
                    additionalInformationAllowSkip: true,
                    additionalInformationValueIfSkipped: 'Stagiaire',
                    customerShowUpNotification: false,
                    sendReminderEmailShowUpNotification: false,
                    delayBeforeSendingReminderEmailShowUpNotification: 30,
                    created_at: '2018-04-10T14:40:24.000Z',
                    updated_at: '2021-02-11T15:27:40.000Z',
                    deleted_at: null,
                },
                {
                    consumptionModeId: 107,
                    type: 'MODE_SIT_IN',
                    flags: 0,
                    fee: 0,
                    labelFee: null,
                    reduction: 0,
                    labelReduction: null,
                    delay: 0,
                    moduleStripeId: null,
                    stuartId: null,
                    moduleIngenicoId: null,
                    restaurantId: 65,
                    brandId: 10,
                    channelId: 2,
                    isTimeSlotModeEnabled: false,
                    additionalInformationType: 'TABLE_NUMBER',
                    additionalInformationTitle: 'Saisissez votre numéro de table',
                    additionalInformationAllowSkip: true,
                    additionalInformationValueIfSkipped: 'Aucune table attribuée',
                    customerShowUpNotification: false,
                    sendReminderEmailShowUpNotification: false,
                    delayBeforeSendingReminderEmailShowUpNotification: 30,
                    created_at: '2018-04-10T14:40:25.000Z',
                    updated_at: '2021-02-02T14:16:40.000Z',
                    deleted_at: null,
                },
            ],
            moduleLoyaltyRoyalties: [
                {
                    moduleLoyaltyRoyaltyId: 13,
                    is_enabled: true,
                    percentage: 8000,
                    moduleId: 17,
                    brandId: null,
                    restaurantId: 65,
                    channelId: 6,
                    customCss:
                        '#intro * {\n    margin: 0;\n    padding: 0;\n}\n\n#intro .description {\n    margin-top: 20px;\n    margin-bottom: 50px;\n    width: 80%;\n    text-align: center;\n}\n\n#intro .content-container {\n    width: 100%;\n    padding-bottom: 30px;\n}\n\n#intro .content-container h4 {\n    text-align: center;\n    margin-bottom: 10px;\n}\n\n\n#intro .content-container .perks {\n    background-color: #fdfdfd;\n    border: solid 1px #e2e2e2;\n    padding: 20px 0;\n    width: 100%;\n    margin: 10px 0;\n}\n\n#intro .content-container .perks h5 {\n    font-family: avenir-heavy;\n    text-transform: uppercase;\n}\n\n#intro .content-container .perks i {\n    /*color: $brand-color;*/\n    font-size: 24px;\n}\n\n#intro .content-container .perks p {\n    font-size: 12px;\n}\n    \n#intro .content-container fio-button {\n    /*background-color: $brand-color;*/\n    font-size: 20px;\n    font-family: avenir-heavy;\n    padding: 15px 70px;\n    border-radius: 4px;\n    /*color: $text-on-brand;*/\n    margin-bottom: 20px;\n}',
                    customHtmlMessage:
                        '<div layout="column" layout-align="center center">\n    <p class="description">Grâce à votre carte de fidélité Fresh Burritos, vous cumulez des euros à chacune de vos visites dans nos restaurants ou de vos commandes passées sur notre site internet.</p>\n    <section class="content-container">\n        <h4>Découvrez les avantages de la carte de fidélité</h4>\n        <div class="perks" layout="row" layout-align="space-around center">\n            <i class="icon icon-feed-price"></i>\n            <div flex="80">\n                <h5>5% DE VOTRE NOTE CRÉDITÉ EN AVOIR</h5>\n                <p>sur votre carte à chaque passage en caisse</p>\n            </div>\n        </div>\n        <div class="perks" layout="row" layout-align="space-around center">\n            <i class="icon icon-feed-wallet"></i>\n            <div flex="80">\n                <h5>VOTRE COMPTE FIDÉLITÉ</h5>\n                <p>consultable à tout moment sur internet.</p>\n            </div>\n        </div>\n        <div class="perks" layout="row" layout-align="space-around center">\n            <i class="icon icon-coin-euro"></i>\n            <div flex="80">\n                <h5>VOTRE SOLDE D\'EUROS SAUVEGARDÉ</h5>\n                <p>même en cas de perte de votre carte ! </p>\n            </div>\n        </div>\n    </section>\n</div>\n',
                    created_at: '2018-04-10T09:38:57.000Z',
                    updated_at: '2022-04-15T08:41:13.000Z',
                    deleted_at: null,
                },
            ],
            address: {
                addressId: 1040,
                lat: 48.865165,
                lng: 2.352221,
                timeZoneId: 'Europe/Paris',
                locality: 'Paris',
                route: 'Boulevard de Sébastopol',
                postalCode: '75003',
                streetNumber: '80',
                administrativeAreaLevel1: 'Île-de-France',
                administrativeAreaLevel2: 'Arrondissement de Paris',
                country: 'France',
                googlePlaceId: 'ChIJId-sFBpu5kcRlRW_9X09GYg',
                providerId: 'ChIJId-sFBpu5kcRlRW_9X09GYg',
                phone: null,
                additionalInfo: null,
                digiCode: null,
                apartmentNumber: null,
                iconIdentifier: null,
                customerId: null,
                name: '80 Boulevard de Sébastopol, 75003 Paris, France',
                created_at: '2018-04-09T13:53:41.000Z',
                updated_at: '2020-10-20T07:55:42.000Z',
                deleted_at: null,
            },
        },
    ],
    consumptionModesFlag: 15,
    stripeEnabled: true,
    isCNTRELuncheonVoucherDeclared: true,
} as unknown as WeborderingConfiguration;
